import React from 'react';
import ReactDOM from 'react-dom';

var firebase = require('firebase/app');
require("firebase/database");

var _ = require('underscore');
var moment = require("moment-timezone");
var createReactClass = require('create-react-class');
var PropTypes = require('prop-types');
var lines = 10;

firebase.initializeApp(config);

function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] === variable) { return pair[1]; }
    }
    return false;
}

function changeText(e) {
    e.css('visibility', 'hidden');
    e.parent().css('transform', 'scaleX(1)');

    var scalex = (e.parent().parent().width()) / e.width() > 1 ? 1 : (e.parent().parent().width()) / e.width();
    e.parent().css('transform', 'scaleX(' + scalex + ')');
    e.css('visibility', 'visible');
}

// Menu Icon
function IconMenu() {
    return (
        <svg className="icon-menu" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <title>menu</title>
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
            <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
        </svg>
    );
}

// Arrow Icon
function IconArrowBack() {
    return (
        <svg className="icon-menu" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <title>arrow-back</title>
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
        </svg>
    );
}

// Arrow Done
function IconDone() {
    return (
        <svg className="icon-menu" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <title>done</title>
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
        </svg>
    );
}


window.setClockNetwork = function (network) {

    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/api/SyncGraphics/SetClockNetwork/' + mid + '/' + network, true);
    //xhr.setRequestHeader("Content-type", "application/json");
    xhr.send();
};



window.showAthlete = function (eid, result, lanepos, entryNote = 0, heat = 0, includePBSB=true) {
    var data = "";
    var position = document.getElementById("centerLT").value;
    var noteAdd = result ? document.getElementById("markAdd").value : "";
    if (noteAdd != "")
        document.getElementById("markAdd").value = "";

    //if ($("#addNote").val() !== "") {
    //    data = '{"gu":' + window.globalGU + ',"eid":' + eid + ',"result": ' + result + ', "lanepos":' + lanepos + ', "addNote":"' + $("#addNote").val() + '" }';
    //} else {
    data = '{"gu":' + window.globalGU + ',"eid":' + eid + ',"heat":' + heat + ',"result": ' + result + ', "lanepos":' + lanepos + ', "addNote":"' + noteAdd + '","position":"' + position + '","entryNote": ' + entryNote + ',"includePBSB":' + includePBSB+'}';
    //}

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/api/SyncGraphics/ShowAthleteLowerThird/' + window.globalMID, true);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.send(data);
};

window.showRowingCrew = function (eid, result, lanepos, entryNote = 0, heat = 0, includePBSB = true) {
    var data = "";
    var position = document.getElementById("centerLT").value;
    var noteAdd = result ? document.getElementById("markAdd").value : "";
    if (noteAdd != "")
        document.getElementById("markAdd").value = "";

    //if ($("#addNote").val() !== "") {
    //    data = '{"gu":' + window.globalGU + ',"eid":' + eid + ',"result": ' + result + ', "lanepos":' + lanepos + ', "addNote":"' + $("#addNote").val() + '" }';
    //} else {
    data = '{"gu":' + window.globalGU + ',"eid":' + eid + ',"heat":' + heat + ',"result": ' + result + ', "lanepos":' + lanepos + ', "addNote":"' + noteAdd + '","position":"' + position + '","entryNote": ' + entryNote + ',"includePBSB":' + includePBSB + '}';
    //}

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/api/SyncGraphics/ShowRowingCrew/' + window.globalMID, true);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.send(data);
};

window.showRelayNames = function (eid, result, lanepos, entryNote = 0, heat = 0, includePBSB = true) {
    var data = "";

    var noteAdd = result ? document.getElementById("markAdd").value : "";
    if (noteAdd != "")
        document.getElementById("markAdd").value = "";

    //if ($("#addNote").val() !== "") {
    //    data = '{"gu":' + window.globalGU + ',"eid":' + eid + ',"result": ' + result + ', "lanepos":' + lanepos + ', "addNote":"' + $("#addNote").val() + '" }';
    //} else {
    data = '{"gu":' + window.globalGU + ',"eid":' + eid + ',"heat":' + heat + ',"result": ' + result + ', "lanepos":' + lanepos + ', "addNote":"' + noteAdd + '","entryNote": ' + entryNote + ',"includePBSB":' + includePBSB + '}';
    //}

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/api/SyncGraphics/ShowRelayLineup/' + window.globalMID, true);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.send(data);
};

window.showCard = function (eid, action) {
    var data = "";

    var noteAdd = document.getElementById("markAdd").value;

    switch (noteAdd.toUpperCase()) {
        case "1":
            noteAdd = "Leader";
            break;
        case "2":
            noteAdd = "2nd";
            break;
        case "3":
            noteAdd = "3rd";
            break;
        case "4":
            noteAdd = "4th";
            break;
        case "5":
            noteAdd = "5th";
            break;
        case "L":
            noteAdd = "Leader";
            break;
        case "B":
            noteAdd = "Breakaway";
            break;
        case "C":
            noteAdd = "Chase";
            break;
        case "C2":
            noteAdd = "Chase 2";
            break;
        case "P":
            noteAdd = "Peloton";
            break;
        case "IC":
            noteAdd = "IRONMAN Champion";
            break;
    }


    if (noteAdd !== "")
        document.getElementById("markAdd").value = "";


    data = '{"gu":' + window.globalGU + ',"eid":' + eid + ', "addNote":"' + noteAdd + '", "action":"' + action + '"}';

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/api/SyncGraphics/ShowCard/' + window.globalMID, true);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.send(data);
};

window.clearAll = function () {
    var xhr = new XMLHttpRequest();
    var data = '{"gu":' + window.globalGU + ',"mid":' + window.globalMID + ' }';
    xhr.open('POST', '/api/SyncGraphics/ClearGraphics/' + window.globalMID, true);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.send(data);
};

window.toggleSplit = function (on) {
    var xhr = new XMLHttpRequest();
    var data = '{"gu":' + window.globalGU + ',"mid":' + window.globalMID + ',"on":' + on + ' }';
    xhr.open('POST', '/api/SyncGraphics/ToggleSplits/' + window.globalMID, true);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.send(data);
};

window.toggleShowSplit = function (on) {
    var xhr = new XMLHttpRequest();
    var data = '{"gu":' + window.globalGU + ',"mid":' + window.globalMID + ',"on":' + on + ' }';
    xhr.open('POST', '/api/SyncGraphics/ToggleShowSplits/' + window.globalMID, true);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.send(data);
}; 

window.toggleIsolynx = function (on) {
    var xhr = new XMLHttpRequest();
    var data = '{"gu":' + window.globalGU + ',"mid":' + window.globalMID + ',"on":' + on + ' }';
    xhr.open('POST', '/api/SyncGraphics/ToggleIsolynx/' + window.globalMID, true);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.send(data);
};

window.showSpeed = function (on) {
    var xhr = new XMLHttpRequest();
    var data = '{"gu":' + window.globalGU + ',"mid":' + window.globalMID + ',"on":' + on + ' }';
    xhr.open('POST', '/api/SyncGraphics/ToggleSpeed/' + window.globalMID, true);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.send(data);
};

window.turnoffSidebar = function (on) {
    var xhr = new XMLHttpRequest();
    var data = '{"gu":' + window.globalGU + ',"mid":' + window.globalMID + ',"on":' + on + ' }';
    xhr.open('POST', '/api/SyncGraphics/TurnOffSidebar/' + window.globalMID, true);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.send(data);
};

window.clearCC = function (flight) {
    var xhr = new XMLHttpRequest();
    var data = '{"gu":' + window.globalGU + ',"mid":' + window.globalMID + ',"flight":' + flight + ' }';
    xhr.open('POST', '/api/SyncGraphics/ClearCC/' + window.globalMID, true);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.send(data);
};

window.clearCRND = function (flight) {
    var xhr = new XMLHttpRequest();
    var data = '{"gu":' + window.globalGU + ',"mid":' + window.globalMID + ',"flight":' + flight + ' }';
    xhr.open('POST', '/api/SyncGraphics/ClearCRND/' + window.globalMID, true);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.send(data);
};

window.clearCHT = function (flight) {
    var xhr = new XMLHttpRequest();
    var data = '{"gu":' + window.globalGU + ',"mid":' + window.globalMID + ',"flight":' + flight + ' }';
    xhr.open('POST', '/api/SyncGraphics/ClearCHT/' + window.globalMID, true);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.send(data);
};

window.enableSplit = function (on) {
    var xhr = new XMLHttpRequest();
    var data = '{"gu":' + window.globalGU + ',"mid":' + window.globalMID + ',"on":' + on + ' }';
    xhr.open('POST', '/api/SyncGraphics/EnableSplits/' + window.globalMID, true);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.send(data);
};

window.showLine2 = function (eid) {
    var data = "";

    //if ($("#addNote").val() !== "") {
    //    data = '{"gu":' + window.globalGU + ',"eid":' + eid + ',"result": ' + result + ', "lanepos":' + lanepos + ', "addNote":"' + $("#addNote").val() + '" }';
    //} else {
    data = '{"gu":' + window.globalGU + ',"eid":' + eid + ' }';
    //}

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/api/SyncGraphics/ShowLine2/' + window.globalMID, true);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.send(data);
};


window.showVAttempt = function (eid, an, height, attempt) {

    var twoboxValue = document.getElementById("twobox").value;
    var data = '{"gu":' + window.globalGU + ',"eid":' + eid + ',"an":' + an + ',"attempt":' + attempt + ',"height":' + height + ',"mode":"' + window.globalMode +'","twobox":"'+twoboxValue+'"}';

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/api/SyncGraphics/ShowVAttempt/' + eid, true);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.send(data);
}
window.showHAttempt = function (eid, an, attempt) {
    var twoboxValue = document.getElementById("twobox").value;
    var data = '{"gu":' + window.globalGU + ',"eid":' + eid + ',"an":' + an + ',"attempt":' + attempt + ',"mode":"' + window.globalMode + '","twobox":"' + twoboxValue +'"}';

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/api/SyncGraphics/ShowHAttempt/' + eid, true);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.send(data);
}

var FranklinApp = createReactClass({
    displayName: 'AppRoot',
    getDefaultProps: function () {
        return {
            meetID: 1152
        };
    },
    getInitialState: function () {
        return {
            liveEvents: null,
            schedule: [],
            scores: [],
            currentEvent: null,
            meta: {},
            leftNav: false,
            selectedAthlete: null,
            hRight: null,
            vRight: null,
            selectedDay: moment().format("ddd, MMMM Do"),
            enr: null,
            activeTab: "results",
            localTZ: true,
            showFlag: false,
            showLogo: false,
            isScored: false,
            showFullScore: false,
            eid: null,
            records: null,
            baseRef: firebase.database().ref(this.props.meetID),
            gu: null
        };
    },
    componentWillMount: function () {
        var meetID = this.props.meetID;
        var metaRef = this.state.baseRef.child('Meta');
        var t = this;
        metaRef.once('value')
            .then(function (dataSnapshot) {
                var meta = dataSnapshot.val();
                meta.showLogo = meta.showLogo == undefined ? false : meta.showLogo;
                meta.showFlag = meta.showFlag == undefined ? false : meta.showFlag;
                meta.LS = meta.LS == undefined ? false : meta.LS;

                t.setState({ meta: meta, showFlag: meta.showFlag, showLogo: meta.showLogo, isScored: meta.LS });
                var url = "/css/" + meta.css + "?cb=04142017A";
                var head = document.getElementsByTagName('head')[0];
                var link = document.createElement('link');

                link.setAttribute('rel', 'stylesheet');
                link.setAttribute('href', url);
                link.setAttribute('type', 'text/css');
                head.appendChild(link);
                document.title = meta.name;
                if (meta.LS) {
                    var scoresRef = t.state.baseRef.child('Scores').orderByChild('L');
                    t.firebaseCallback = scoresRef.on('value', function (snap) {
                        var scoreItems = [];
                        snap.forEach(function (itemSnap) {
                            scoreItems.push(itemSnap.val());
                        });
                        t.setState({ scores: scoreItems });
                    });
                }
            });
        var scheduleRef = this.state.baseRef.child('Schedule').orderByChild('T');
        this.firebaseCallback = scheduleRef.on('value', function (snap) {
            var scheduleItems = [];
            snap.forEach(function (itemSnap) {
                scheduleItems.push(itemSnap.val());
            });
            t.setState({ schedule: scheduleItems });
        });

    },
    componentWillUnmount: function () {
        this.state.baseRef.off();
        this.state.baseRef.child('/MeetEvents/' + this.state.enr).off();
    },
    handleDayClick: function (day) {
        if (day === this.state.selectedDay) {
            this.setState({ selectedDay: null });
        } else {
            this.setState({ selectedDay: day });
        }
    },
    handleEventClick: function (enr) {
        var prevENR = this.state.enr;
        var t = this;
        if (enr !== prevENR) {

            this.setState({ hRight: null, vRight: null });

            var eventRef = this.state.baseRef.child('/MeetEvents/' + enr);

            if (prevENR === "live") {
                this.state.baseRef.child('/MeetEvents/').orderByChild('EIP').startAt(1).off();
            }
            //else {
            this.state.baseRef.child('/MeetEvents/' + prevENR).off();
            //}

            t.setState({ selectedAthlete: null, activeTab: "results", records: null });

            eventRef.on('value', function (snapshot) {
                t.setState({ currentEvent: snapshot.val(), liveEvents:null, enr: enr, leftNav: false, showFullScore: false });
            });
            var recordsRef = this.state.baseRef.child('Records/' + enr);
            recordsRef.once('value').then(function (dataSnapshot) {
                var records = dataSnapshot.val();
                t.setState({ records: records });
            });
        }
    },
    handleLiveClick: function (enr) {
        var prevENR = this.state.enr;
        var t = this;
        if (enr !== prevENR) {
            t.setState({ selectedAthlete: null, activeTab: "results", records: null });
            var liveRef = this.state.baseRef.child('/MeetEvents/').orderByChild('EIP').startAt(1);
            this.state.baseRef.child('/MeetEvents/' + prevENR).off();
            liveRef.on('value', function (snapshot) {
                t.setState({ currentEvent: null, liveEvents: snapshot.val(), completedEvents: null, enr: enr, leftNav: false, showFullScore: false });
            });
        }
    },
    handleTabClick: function (tab) {
        this.setState({ activeTab: tab });
    },
    handleAthleteClick: function (aid, category, attempts, eid) {
        var athleteInfo;
        if (attempts === undefined) attempts = [];
        if (category == "h") {
            this.setState({ hRight: attempts, vRight: null, eid: eid });
        }

        if (category == "v") {
            this.setState({ vRight: attempts, hRight: null, eid: eid });
        }
        //var t = this;
        //var firebaseAthleteRef = this.state.baseRef.child('/Athletes/' + aid);
        //firebaseAthleteRef.once('value')
        //  .then(function (dataSnapshot) {
        //      athleteInfo = dataSnapshot.val();
        //      t.setState({selectedAthlete: athleteInfo});
        //  });  
    },
    handleTZChange: function (onoff, e) {
        if (onoff) {
            this.setState({ localTZ: onoff });
        } else {
            this.setState({ localTZ: onoff });
        }
        e.stopPropagation();

    },
    showLeftMenu: function () {
        this.setState({ leftNav: true });
    },
    hideMenus: function () {
        this.setState({ leftNav: false, selectedAthlete: null, hRight: null, vRight: null });
    },
    handleFullScoreClick: function () {
        if (this.state.enr !== null) {
            this.state.baseRef.child('/MeetEvents/' + this.state.enr).off();
        }
        this.setState({ showFullScore: true, selectedAthlete: null, currentEvent: null, leftNav: false, hRight: null, vRight: null });
    },
    setGU: function (event) {
        var now = new Date();
        //5 days * 24 hours/day * 3600 seconds/hour
        now.setTime(now.getTime() + 5 * 24 * 3600 * 1000);

        document.cookie = "gu=" + event.target.value + "; expires=" + now.toUTCString() + "; path=/";
        window.globalGU = event.target.value;
        graphicsUnit = event.target.value;
        this.setState({ gu: event.target.value });
    },
    setMode: function (event) {
        window.globalMode = event.target.value;
        gfxMode = event.target.value;
    },
    showTeamScores(lid) {
        var data = "";
        data = '{"gu":' + window.globalGU + ',"mid":' + window.globalMID + ',"level":"' + lid + '"}';

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/ShowTeamScores/' + window.globalMID, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    },
    showEventGraphics: function () {
        var prevENR = this.state.enr;

            this.setState({ hRight: null, vRight: null });

            
            if (prevENR === "live") {
                this.state.baseRef.child('/MeetEvents/').orderByChild('EIP').startAt(1).off();
            }

            this.state.baseRef.child('/MeetEvents/' + prevENR).off();
        
        this.setState({ currentEvent: null, enr: 0 });
    },
    render: function () {
        var showFullScore = this.state.showFullScore;
        var currentEvent = this.state.currentEvent;
        var liveEvents = this.state.liveEvents;
        var ce = null, back = null, title = null;
        var topnavClass = "topNav";
        var secnavClass = "secNav tabstrip";
        var osl = this.state.showLogo;
        var osf = this.state.showFlag;
        var contentClass = "content";
        var leftNavClass = "leftNav", overlayClass = "", rightNavClass = "rightBar", overlayRightClass = "";
        var resultTabClass = this.state.activeTab == "results" ? "tab active" : "tab";
        var recordsTabClass = this.state.activeTab == "records" ? "tab active" : "tab";;
        var rb;
        var roundName = null;
        var evtStatus = "";
        var scoreBar = null;
        var scoreStyle = "";
        var scoreLink = null;
        var eventNav = null;
        if (this.state.leftNav) {
            leftNavClass += " open";
            overlayClass += "navOpen";
        }
        var secNavTab = "Results";

        if (this.state.hRight || this.state.vRight) {
            rightNavClass += " open";
            overlayRightClass += "navOpen";
            if (this.state.hRight) {
                rb = <RightBar ce={this.state.currentEvent} meta={this.state.meta} category="h" eid={this.state.eid} />;
            } else {
                rb = <RightBar ce={this.state.currentEvent} meta={this.state.meta} category="v" eid={this.state.eid} />;
            }

        }
        var meetHome = [];

        //if (this.state.isScored) {
        //    scoreBar = <ScoreBar scores={this.state.scores } fullScoreClick={this.handleFullScoreClick}></ScoreBar>;
        //    scoreStyle = " withScores";
        //    scoreLink = <div><hr /><div className="eventLink day" onClick={() => this.handleFullScoreClick()} ><b>Team Scores</b></div><hr/></div>
        //}

        //topnavClass += scoreStyle;
        //secnavClass += scoreStyle;
        //contentClass += scoreStyle;
        //leftNavClass += scoreStyle;
        //rightNavClass += scoreStyle;

        //if (showFullScore) {
        //    title = <div id="appBarTitle">{this.state.meta.name}</div>;
        //    ce = <ScoresFull scores={this.state.scores } fullScoreClick={this.handleFullScoreClick}></ScoresFull>
        //    eventNav =<div id="eventNav" className="stripNav">
        //            <div className={resultTabClass}>Team Scores</div>

        //    </div>
        //} else 

        var guStyle = { background: "#FFF", color: "#000", border: "solid 1px #000", fontWeight: "bold", padding: "0px 10px", fontSize: "1.1em", display: "inline-block" };
        let showClear = this.state.gu === null || this.state.gu === "" ? "none" : "inline-block";
        var clearStyle = { background: "#FFF", color: "red", border: "solid 1px red", fontWeight: "bold", padding: "0px 10px", fontSize: "1.1em", display: showClear, marginRight:"10px", textTransform: "uppercase" };
        if (liveEvents) {
            ce = <LiveEvents liveEvents={liveEvents} meta={this.state.meta} osl={osl} osf={osf} athleteClick={this.handleAthleteClick} />;
            eventNav = <div id="eventNav" className="stripNav"></div>;
            title = <div id="appBarTitle"><div><span className='eventDateTime'>Live Now</span></div>Events in Progress</div>;
            topnavClass += " eventTitle";
            contentClass += " event noScorll";
        } else if (currentEvent) {
            if (this.state.activeTab == "results") {
                ce = <SelectedEvent currentEvent={currentEvent} meta={this.state.meta} osl={osl} osf={osf} athleteClick={this.handleAthleteClick} records={this.state.records} />;
            } else if (this.state.activeTab == "records") {
                ce = <Records records={this.state.records} />
            }
            back = <button id="eventArrowBack" className="icon"><IconArrowBack /></button>;
            if (currentEvent.RN) {

                roundName = currentEvent.RN == "Final" ? <span> | <b>{currentEvent.RN}</b></span> : <span> | {currentEvent.RN}</span>
            }
            var mTime = this.state.localTZ ? moment(currentEvent.T).format("dddd h:mm A") : moment.parseZone(currentEvent.T).format("dddd h:mm A")
            title = <div id="appBarTitle"><div><span className='eventDateTime'>{mTime} {roundName}</span></div><span className="gu" style={guStyle}>{this.state.gu}</span><span style={clearStyle} onClick={() => window.clearAll()}>Clear</span>{currentEvent.N}</div>;
            topnavClass += " eventTitle";
            evtStatus = currentEvent.S.replace(" ", "").toLowerCase()
            secnavClass += " event " + evtStatus;
            contentClass += " event noScorll";

            eventNav = <div id="eventNav" className="stripNav">
                <div data-tab="result" className={resultTabClass} onClick={() => this.handleTabClick("results")}>
                    {secNavTab}
                </div>
                <div id="recordsTab" data-tab="records" className={recordsTabClass} onClick={() => this.handleTabClick("records")}>
                    Records
                    </div>
            </div>;

        }
        else {
            title = <div id="appBarTitle"><span className="gu" style={guStyle}>{this.state.gu}</span><span style={clearStyle} onClick={() => window.clearAll()}>Clear</span>{this.state.meta.name}</div>;
            ce = <EventGraphics mid={this.props.meetID} meta={this.state.meta} />;
            eventNav = <div id="eventNav" className="stripNav">
                <div className={resultTabClass}>Select an event from the&nbsp;<span className="mobile">top</span><span className="notmobile">side</span>&nbsp;menu
                    </div>
            </div>
        }

        if (evtStatus === "notstarted" || evtStatus === "upnext") {
            secNavTab = "Start List";
        }

        let scoresButtons = this.state.scores.map(sl => <button className="btn btn-status btn-outline-info btn-filter btn-sm" onClick={() => this.showTeamScores(sl.L)}>{sl.L}</button>);


        if (this.state.meta.css && this.state.schedule.length > 0)
            return (
                <div>
                    {scoreBar}
                    <div id="overlay" className={overlayClass} onClick={this.hideMenus}></div>
                    <div id="overlayRight" className={overlayRightClass} onClick={this.hideMenus}></div>
                    <nav className={topnavClass}>
                        <button id="leftNavOpen" className="icon" onClick={this.showLeftMenu}><IconMenu /></button>
                        {title}
                    </nav>

                    <nav className={leftNavClass} id="leftNav">
                        <div className="header">
                            <img src={"/img/" + this.state.meta.logo} />
                            {this.state.meta.name}
                        </div>
                        <div className="day">
                            <select id="guSelect" onChange={this.setGU}>
                                <option value="">Set Graphics Unit</option>
                                <option value="1">Track - Graphics 1</option>
                                <option value="2">F1 - Graphics 2</option>
                                <option value="3">F2 - Graphics 3</option>
                                <option value="4">F3 - Graphics 4</option>
                                <option value="5">TEST - Graphics 5</option>
                            </select>
                            <br />
                            <select id="modeSelect" onChange={this.setMode}>
                                <option value="Live">Live</option>
                                <option value="Back">Back In Time</option>
                               
                            </select>

                            <select id="centerLT">
                                <option value="center">Center LT</option>
                                <option value="left">Left LT</option>
                                <option value="right">Right LT</option>

                            </select>
                            <select id="twobox">
                                <option value="">No Twobox</option>
                                <option value="tbLeft">Left</option>
                                <option value="tbRight">Right</option>

                            </select>
                        </div>
                        <div className="day"><b>Clock</b>&nbsp;&nbsp;
                            <button onClick={() => window.setClockNetwork(1)} className="btn btn-status btn-outline-primary btn-filter btn-sm" role="button">Oval</button>&nbsp;&nbsp;
                            <button onClick={() => window.setClockNetwork(2)} className="btn btn-status btn-outline-info btn-filter btn-sm" role="button">Sprint</button>
                        </div>
                        <hr />
                        <div className="day" onClick={() => window.clearAll()}><b>Clear All</b></div>
                        <hr />
                        <div className="day" onClick={() => this.showEventGraphics()}><b>Event Graphics</b></div>
                        <hr />
                        <div className="day">Team Scores:&nbsp;&nbsp; {scoresButtons} </div>
                        <hr />
                        <ScheduleDay schedule={this.state.schedule} meta={this.state.meta} selectedDay={this.state.selectedDay} localTZ={this.state.localTZ} tzClick={this.handleTZChange} dayClick={this.handleDayClick} eventClick={this.handleEventClick} />

                    </nav>

                    <nav className={secnavClass}>
                        <div id="liveNav" className="hide">
                            <div data-tab="result" className="tab active">
                                Event Graphics
                    </div>
                        </div>
                        {eventNav}
                    </nav>

                    <div id="rightBar" className={rightNavClass}>
                        {rb}
                    </div>

                    <div className={contentClass} id="content">
                        <div id="liveContent" className="hide">

                        </div>

                        <div id="eventContent">
                            {ce}
                        </div>
                    </div>
                </div>
            );
        else
            return (<div className="loading">
                <div className="spinner">
                    <div className="double-bounce1"></div>
                    <div className="double-bounce2"></div>
                </div>Loading Data</div>);
    }
});

class RightBar extends React.Component {
    constructor(props) {
        super(props);
    }
    loadAAPage(AA) {
        window.open('http://www.all-athletics.com/node/' + AA, 'Athlete Detail');
    }
    loadTFRRSPage(TF) {
        window.open('https://www.tfrrs.org/athletes/' + TF, 'TFRRS Profile');
    }

    render() {
        var meta = this.props.meta;
        var athleteInfo = this.props.athleteInfo;
        var eid = this.props.eid;
        var category = this.props.category;
        var attempts;
        var t = this;

        var attemptArray = [];
        if (category == "h") {
            attempts = this.props.ce.ED[eid].hasOwnProperty("HAD") ? this.props.ce.ED[eid].HAD : [{ AN: 1 }];
            var len = attempts.length;

            _.sortBy(attempts, 'AN').forEach(function (ele) {
                if (ele == undefined) {
                    len--;
                } else {
                    attemptArray.push(<tr key={"ha-" + eid + "-" + ele.AN}><td>{ele.AN}</td><td>{ele.M}</td><td><button onClick={() => window.showHAttempt(eid, ele.AN, true)}>A</button></td><td><button onClick={() => window.showHAttempt(eid, ele.AN, false)}>R</button></td></tr>);
                }
            });

            if (len < 6) {
                attemptArray.push(<tr key={"ha-" + eid + "-" + (len + 1)}><td>{(len + 1)}</td><td>_</td><td><button onClick={() => window.showHAttempt(eid, len + 1, true)}>A</button></td><td></td></tr>);
            }
        }

        if (category == "v") {
            attempts = this.props.ce.ED[eid].hasOwnProperty("VAD") ? this.props.ce.ED[eid].VAD : [{ AN: 1 }];
            var heights = this.props.ce.H.split(",");
            var va = [];
            _.each(heights, function (ele) {
                var height = _.findWhere(attempts, { H: parseFloat(ele) });
                va = [];
                if (height) {
                    var vattempts = height.A;
                    var success = false;
                    var x;

                    for (x = 0; x < vattempts.length; x++) {
                        if (x == 0) {
                            va.push(<tr key={"va-" + eid + "-" + x + "-" + ele}><td>{vattempts.charAt(x)}</td><td><button onClick={() => window.showVAttempt(eid, 1, ele, true)}>A</button></td><td><button onClick={() => window.showVAttempt(eid, 1, ele, false)}>R</button></td></tr>);
                        } else if (x == 1) {
                            va.push(<tr key={"va-" + eid + "-" + x + "-" + ele}><td>{vattempts.charAt(x)}</td><td><button onClick={() => window.showVAttempt(eid, 2, ele, true)}>A</button></td><td><button onClick={() => window.showVAttempt(eid, 2, ele, false)}>R</button></td></tr>);
                        } else {
                            va.push(<tr key={"va-" + eid + "-" + x + "-" + ele}><td>{vattempts.charAt(x)}</td><td><button onClick={() => window.showVAttempt(eid, 3, ele, true)}>A</button></td><td><button onClick={() => window.showVAttempt(eid, 3, ele, false)}>R</button></td></tr>);
                        }
                        if (vattempts.charAt(x) == "O") {
                            success = true;
                            break;
                        }
                    }
                    if (vattempts.length < 3 && !success) {
                        va.push(<tr key={"va-" + eid + "-" + (vattempts.length + 1) + "-" + ele}><td>_</td><td><button onClick={() => window.showVAttempt(eid, vattempts.length + 1, ele, true)}>A</button></td><td></td></tr>);
                    }
                } else {
                    va.push(<tr key={"va-" + eid + "-1-" + ele}><td>_</td><td><button onClick={() => window.showVAttempt(eid, 1, ele, true)} >A</button></td><td></td></tr>);
                }
                attemptArray.push(<tr key={"va-" + eid + "-" + ele}><td>{ele}</td><td><table><tbody>{va}</tbody></table></td></tr>);
            });
        }

        return (
            <div className="teamEventBar">
                <div className="heading">
                    Attempts
                </div>
                <div className="rb-content">
                    <table>
                        <tbody>
                            {attemptArray}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

class ScheduleDay extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {

        var skedSort = this.props.meta.hasOwnProperty("skedSort") ? this.props.meta.skedSort : "Session";
        var levelNav = this.props.meta.hasOwnProperty("levelNav") ? this.props.meta.levelNav : false;
        //this.props.meetEvents.sort(function (a, b) {
        //    if (Date.parse(a.DayTime) > Date.parse(b.DayTime)) {
        //        return 1;
        //    }
        //    if (Date.parse(a.DayTime) < Date.parse(b.DayTime)) {
        //        return -1;
        //    }
        //    return 0;
        //});

        var sked = {};
        var localTZ = this.props.localTZ;
        var score;

        var schedule = this.props.schedule.reduce((sked, n) => {
            var d = localTZ ? moment(n.T).format("ddd, MMMM Do") : moment.parseZone(n.T).format("ddd, MMMM Do");
            (sked.levels[n.L] = sked.levels[n.L] || []).push(n);
            (sked.days[d] = sked.days[d] || []).push(n);
            return sked;
        }, { levels: {}, days: {} });

        var eventClick = this.props.eventClick;
        var dayClick = this.props.dayClick;
        var selectedDay = this.props.selectedDay;
        var localClass = localTZ ? "tzActive" : "tzInactive";
        var eventClass = localTZ ? "tzInactive" : "tzActive";
        var timezone;

        if (Object.keys(schedule.days).length == 1 && !levelNav) {
            var prop; for (prop in schedule.days) break;
            selectedDay = prop;
        }

        if (moment.parseZone(this.props.schedule[0].T).format("Z") == moment().format("Z")) {
            timezone = <div className="timezone"><span className={localClass}>Local ({moment().tz(moment.tz.guess()).format('z')})</span></div>;
        } else {
            timezone = <div className="timezone"><a className={localClass} onClick={(e) => this.props.tzClick(true, e)}>Local ({moment().tz(moment.tz.guess()).format('z')})</a> | <a className={eventClass} onClick={(e) => this.props.tzClick(false, e)}>Event</a></div>;
        }
        var tz = 0;
        var createDay = function (day) {
            tz++;
            //var tzDiv = tz === 1 ? timezone : null;
            var tzDiv = timezone;
            var showDay;
            if (selectedDay === day) {
                if (skedSort == "Time") {
                    schedule.days[day].sort(function (a, b) {
                        var aSO = a.T;
                        var bSO = b.T;
                        if (aSO > bSO) return 1;
                        if (aSO < bSO) return -1;
                        return 0;
                    });
                } else {
                    schedule.days[day].sort(function (a, b) {
                        var aSO = a.HSO ? a.HSO : a.T;
                        var bSO = b.HSO ? b.HSO : b.T;
                        return aSO - bSO;
                    });
                }

                showDay = "dayEvents";
                return <div key={day}><hr /><div className="day" onClick={() => dayClick(day)}><b>{day}</b>{tzDiv}</div><div id="sked" className={showDay}><ScheduleEvent meetEvents={schedule.days[day]} eventClick={eventClick} localTZ={localTZ} /></div></div>;
            } else {
                showDay = "dayEvents hide";
                return <div key={day}><hr /><div className="day" onClick={() => dayClick(day)}><b>{day}</b></div><div id="sked" className={showDay}></div></div>;
            }


        };
        var createLevel = function (level) {
            var showDay;
            if (selectedDay === level) {
                if (level == "Decathlon" || level == "Heptathlon" || level == "Indoor Heptathlon" || level == "Indoor Pentathlon")
                    schedule.levels[level].sort(function (a, b) {
                        return a.R - b.R;
                    });
                else
                    schedule.levels[level].sort(function (a, b) {
                        return a.SO - b.SO;
                    });
                showDay = "dayEvents";
                var tzDiv = timezone;
                return <div key={"sked" + level}><hr /><div className="day" onClick={() => dayClick(level)}><b>{level}</b>{tzDiv}</div><div id="sked" className={showDay}><ScheduleLevelEvent level={level} levelEvent={schedule.levels[level]} eventClick={eventClick} localTZ={localTZ} /></div></div>;
            } else if (level == "Decathlon" || level == "Heptathlon" || level == "Indoor Heptathlon" || level == "Indoor Pentathlon" || levelNav) {
                showDay = "dayEvents hide";
                return <div key={"sked" + level}><hr /><div className="day" onClick={() => dayClick(level)}><b>{level}</b></div><div id="sked" className={showDay}></div></div>;
            }
            else {
                return null;
            }

        };
        var dailyKeys = [], levelKeys = [];
        dailyKeys = Object.keys(schedule.days);  //.reverse()
        levelKeys = Object.keys(schedule.levels);  //.reverse()

        var multiSort = ["Decathlon", "Heptathlon", "Indoor Heptathlon", "Indoor Pentathlon"];

        levelKeys.sort(function (a, b) {
            var ai = multiSort.indexOf(a);
            var bi = multiSort.indexOf(b);

            if (ai > -1 && b > -1) {
                return a - b;
            }
            if (ai > -1 && bi == -1) {
                return -1;
            }
            if (ai == -1 && bi > -1) {
                return 1;
            }
            return a.toUpperCase() > b.toUpperCase();

        });


        return <div key="dailySked">{dailyKeys.map(createDay)}<hr />{levelKeys.map(createLevel)}</div>;

    }
}

class ScheduleEvent extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        var eventClick = this.props.eventClick;
        var currentDay = 0;
        var newDay = null;
        var localTZ = this.props.localTZ

        var createEvent = function (meetEvent, index) {
            var roundName = null;
            if (meetEvent.RN) {
                if (meetEvent.RN == "Final") {
                    roundName = <small><b>{meetEvent.RN}</b></small>;
                } else {
                    roundName = <small>{meetEvent.RN}</small>;
                }

            }
            var status = meetEvent.S.toLowerCase().replace(" ", "");
            var rowClass = "skedRow " + status;
            var mTime = localTZ ? moment(meetEvent.T).format("h:mm A") : moment.parseZone(meetEvent.T).format("h:mm A");
            var timeCol = status === "complete" ? <IconDone /> : <span>{mTime} </span>;
            return (
                <tr key={meetEvent.ENR} className={rowClass} onClick={() => eventClick(meetEvent.ENR)}>
                    <td className="eNumber">{meetEvent.ENR}</td>
                    <td><small>{meetEvent.Sponsor}</small>{meetEvent.N} {roundName}</td>
                    <td className="time">{timeCol}</td>
                </tr>
            );
        };
        return <table className="skedTable"><tbody>{this.props.meetEvents.map(createEvent)}</tbody></table>;
    }
}

class ScheduleLevelEvent extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        var eventClick = this.props.eventClick;
        var localTZ = this.props.localTZ
        var le = this.props.levelEvent
        var ths = null;
        if (this.props.level === "Decathlon" || this.props.level === "Heptathlon" || this.props.level == "Indoor Heptathlon" || this.props.level == "Indoor Pentathlon" || this.props.level === "Exhibition") {

        } else {
            ths = <thead><tr><th>Event</th><th>Final</th><th>Semi</th><th>1st Rnd</th></tr></thead>;
        }

        var levelEvents = le.reduce((l, n) => {
            var eid = n.EID;
            (l[eid] = l[eid] || []).push(n);
            return l;
        }, {});

        var leKeys = Object.keys(levelEvents);
        var createLE = function (le) {
            levelEvents[le].sort(function (a, b) {
                return b.R - a.R;
            });

            var tds = levelEvents[le].map(function (e) {
                var dt = localTZ ? moment(e.T) : moment.parseZone(e.T);
                var status = e.S.toLowerCase().replace(" ", "");
                var tdClass = "dayTime " + status;
                var time = status === "complete" ? <IconDone /> : dt.format("H:mm");
                return <td className={tdClass} onClick={() => eventClick(e.ENR)}>{dt.format("dd, M/D")}<br />{time}</td>
            });
            return <tr><td className="leName">{le}</td>{tds}</tr>
        };
        return <table className="skedTable leTable">{ths}<tbody>{leKeys.map(createLE)}</tbody></table>;
    }
}


class LiveEvents extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {

        var liveEvents = this.props.liveEvents;
        var leArray = [];

        for (var e in liveEvents) {
            leArray.push(liveEvents[e]);
        }

        leArray.sort(function (a, b) {

            if (a.EIP < b.EIP)
                return -1;
            if (a.EIP > b.EIP)
                return 1;

            if (a.T > b.T)
                return -1;
            if (a.T < b.T)
                return 1;
            return 0;
        });


        var athleteClick = this.props.athleteClick;
        var meta = this.props.meta;


        var events = leArray.map(function (key, index) {
            return <LiveEvent key={"le-" + key.ENR} liveEvent={key} meta={meta} athleteClick={athleteClick} />
        });

        return (
            <div id="result" className="tabContent liveResults">
                {events}
            </div>
        );
    }
}

class LiveEvent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { summary: true };
    }
    toggleSummary(meid) {
        this.setState({ summary: !this.state.summary });
    }
    render() {

        var liveEvent = this.props.liveEvent;
        var athleteClick = this.props.athleteClick;
        var meta = this.props.meta;

        var le = null;


        if (liveEvent.S == "Up Next") {
            le = liveEvent.ED ? <StartList currentEvent={liveEvent} hasHeats={liveEvent.HH} athleteClick={athleteClick} meta={meta} eventType={liveEvent.E.C} meid={liveEvent.ID}></StartList> : <div>Entries not available</div>;
        }
        else if (liveEvent.E.C === "RUN" || liveEvent.E.C === "STRAIGHT" || liveEvent.E.C === "RELAY" || liveEvent.E.C === "STAGE" || liveEvent.E.C === "ROAD" || liveEvent.E.C === "XC") {
            if (!liveEvent.HR) {
                liveEvent.HR = false;
            }
            le = liveEvent.ED ? <TrackResults currentEvent={liveEvent} athleteClick={athleteClick} meta={meta} summary={this.state.summary}></TrackResults> : <div>Results currently not available</div>;
        } else if (liveEvent.E.C == "HJUMP" || liveEvent.E.C == "THROW") {

            var overall, current, current2 = null;


            if (liveEvent.hasOwnProperty("CC")) {

            }

            if (liveEvent.hasOwnProperty("CC2")) {

            }
            le = liveEvent.ED ? <HFieldResults currentEvent={liveEvent} athleteClick={athleteClick} meta={meta} summary={this.state.summary}></HFieldResults> : <div>Results currently not available</div>;
        } else if (liveEvent.E.C === "VJUMP") {
            le = liveEvent.ED ? <VFieldResults currentEvent={liveEvent} athleteClick={athleteClick} meta={meta} summary={this.state.summary}></VFieldResults> : <div>Results currently not available</div>;
        } else if (liveEvent.E.C == "MULTI") {
            le = liveEvent.ED ? <MultiResults currentEvent={liveEvent} athleteClick={athleteClick} meta={meta} eventType={liveEvent.L} summary={this.state.summary}></MultiResults> : <div>Results currently not available</div>;
        }

        var statusClass = liveEvent.S.toLowerCase().replace(" ", "");
        var boxClass = "liveEvent " + statusClass;
        var toggle = this.state.summary ? <i className="toggleView" onClick={() => this.toggleSummary(liveEvent.ID)}>Expand to Full View</i> : <i className="toggleView" onClick={() => this.toggleSummary(liveEvent.ID)}>Back to Summary View</i>;


        return (
            <div className={boxClass}>
                <h3><span id="eventResultHeader">{liveEvent.N}</span></h3>
                {toggle}
                <div className={"status " + statusClass}>{liveEvent.S}</div>
                {le}
            </div>
        );
    }
}

class SelectedEvent extends React.Component {
    constructor(props) {
        super(props);
        this.updateStatus = this.updateStatus.bind(this);
        this.showLocator = this.showLocator.bind(this);
        this.showReactime = this.showReactime.bind(this);
        this.setClock = this.setClock.bind(this);
        this.showStartList = this.showStartList.bind(this);
        this.showResults = this.showResults.bind(this);
        this.showTopResults = this.showTopResults.bind(this);
        this.showScoreBug = this.showScoreBug.bind(this);
        this.showL2G = this.showL2G.bind(this);
        this.state = { rtypes: [] };
        this.setForceLap = this.setForceLap.bind(this);
    }
    syncHytek(meid) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', '/api/Sync/SyncHytek/' + meid, true);
        xhr.send(null);
    }
    updateStatus(meid, status) {
        var xhr = new XMLHttpRequest();
        xhr.open('PATCH', '/api/Sync/UpdateStatus/' + meid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send('{"status":"' + status + '"}');
    }
    showLocator(meid, heat) {
        var data = "";
        if (heat > 0) {
            data = '{"gu":' + window.globalGU + ',"meid":' + meid + ', "heat":' + heat + '}';
        } else {
            data = '{"gu":' + window.globalGU + ',"meid":' + meid + '}';
        }


        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/ShowLocator/' + meid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }

    showPrevious(meid) {
        var data = "";
        data = '{"gu":' + window.globalGU + ',"meid":' + meid + '}';
        

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/ShowPrevious/' + meid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    showReactime(meid, heat) {
        var data = "";
        if (heat > 0) {
            data = '{"gu":' + window.globalGU + ',"meid":' + meid + ', "heat":' + heat + '}';
        } else {
            data = '{"gu":' + window.globalGU + ',"meid":' + meid + '}';
        }
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/ShowReactime/' + meid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    showScoreBug(meid) {
        var data = "";
        data = '{"gu":' + window.globalGU + ',"meid":' + meid + '}';
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/ShowScoreBug/' + meid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    setClock(meid, heat, action) {
        var data = "";

        if (heat == 0) {
            data = '{"gu":' + window.globalGU + ', "action":"' + action + '", "meid":' + meid + '}';
        } else {
            data = '{"gu":' + window.globalGU + ', "action":"' + action + '", "meid":' + meid + ',"heat":' + heat + '}';
        }

        var xhr = new XMLHttpRequest();
        xhr.open('PATCH', '/api/SyncGraphics/SetClock/' + meid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    showStartList(meid, heat, page) {
        var data = "";

        if (heat == 0) {
            data = '{"gu":' + window.globalGU + ',"meid":' + meid + ',"page":' + page + ',"fullscreen": false }';
        } else {
            data = '{"gu":' + window.globalGU + ',"meid":' + meid + ',"heat":' + heat + ',"page":' + page + ',"fullscreen": false }';
        }

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/ShowStartList/' + meid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    showStartListSlab(meid, heat, page) {
        var data = "";

        if (heat == 0) {
            data = '{"gu":' + window.globalGU + ',"meid":' + meid + ',"page":' + page + ',"fullscreen": true }';
        } else {
            data = '{"gu":' + window.globalGU + ',"meid":' + meid + ',"heat":' + heat + ',"page":' + page + ',"fullscreen": true }';
        }

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/ShowStartList/' + meid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    showKeyCompetitors(meid, heat, page) {
        var data = "";

        if (heat == 0) {
            data = '{"gu":' + window.globalGU + ',"meid":' + meid + ',"page":' + page + '}';
        } else {
            data = '{"gu":' + window.globalGU + ',"meid":' + meid + ',"heat":' + heat + ',"page":' + page + '}';
        }

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/ShowKeyCompetitors/' + meid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    showResults(meid, heat, page) {
        var data = "";
        var fullscreenValue = document.getElementById("fullscreen").checked;

        if (heat == 0) {
            data = '{"gu":' + window.globalGU + ',"meid":' + meid + ',"page":' + page + ', "fullscreen": ' + fullscreenValue + ',"note":"' + document.getElementById("markAdd").value+'"}';
        } else {
            data = '{"gu":' + window.globalGU + ',"meid":' + meid + ',"heat":' + heat + ',"page":' + page + ', "fullscreen": ' + fullscreenValue + ',"note":"' + document.getElementById("markAdd").value + '"}';
        }

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/ShowResults/' + meid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    showTopResults(meid, count) {
        var data = "";

        data = '{"gu":' + window.globalGU + ',"meid":' + meid + ',"count":' + count + '}';

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/ShowResults/' + meid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);

    }
    showL2G(meid, heat, action, l2g) {
        var data = "";

        if (heat == 0) {
            data = '{"gu":' + window.globalGU + ', "action":"' + action + '", "meid":' + meid + ', "l2g":' + l2g + '}';
        } else {
            data = '{"gu":' + window.globalGU + ', "action":"' + action + '", "meid":' + meid + ',"heat":' + heat + ', "l2g":' + l2g + '}';
        }

        var xhr = new XMLHttpRequest();
        xhr.open('PATCH', '/api/SyncGraphics/SetClock/' + meid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    showRecordChip(meid, rtype) {
        var data = "";
        data = '{"gu":' + window.globalGU + ', "meid":' + meid + ',"rtype":"' + rtype + '"}';


        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/ShowRecordChip/' + meid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    setRecord(meid, rType) {
        if (this.state.rtypes.length < 4 && !this.state.rtypes.includes(rType)) {
            this.setState({ rtypes: this.state.rtypes.concat(rType) });
        } else if (this.state.rtypes.includes(rType)) {
            var rarray = this.state.rtypes;
            rarray.splice(rarray.indexOf(rType), 1);
            this.setState({ rtypes: rarray });
        }
        //alert(meid + "-" + rType);
    }
    showRecords(meid) {
        if (this.state.rtypes.length > 0) {
            var action = "RECORDS";
            var data = "";

            data = '{"gu":' + window.globalGU + ', "action":"' + action + '", "rtypes":"' + this.state.rtypes.join(",") + '","meid":' + meid + '}';

            var xhr = new XMLHttpRequest();
            xhr.open('POST', '/api/SyncGraphics/ShowRecords/' + meid, true);
            xhr.setRequestHeader("Content-type", "application/json");
            xhr.send(data);
        }
    }
    //showRecords(meid) {
    //    if (this.state.rtypes.length > 0) {
    //        var action = "RECORDS";
    //        var data = "";

    //        data = '{"gu":' + window.globalGU + ', "action":"' + action + '", "rtypes":"' + this.state.rtypes.join(",") + '","meid":' + meid + '}';

    //        var xhr = new XMLHttpRequest();
    //        xhr.open('PATCH', '/api/SyncGraphics/SetClock/' + meid, true);
    //        xhr.setRequestHeader("Content-type", "application/json");
    //        xhr.send(data);
    //    }
    //}
    showLeaderboard(meid) {
        var lbBIBs = document.getElementById("lbBIBs").value;
        if (lbBIBs !== "") {
            var lbHeader = document.getElementById("lbHeader").value;
            if (lbHeader === "") lbHeader = "Leaders";

            var lbShowPlace = document.getElementById("lbShowPlace").checked;

            var data = "";

            data = '{"gu":' + window.globalGU + ', "header":"' + lbHeader + '", "bibs":"' + lbBIBs + '","meid":' + meid + ',"showPlace":'+lbShowPlace+'}';

            var xhr = new XMLHttpRequest();
            xhr.open('POST', '/api/SyncGraphics/ShowLeaderboard/' + meid, true);
            xhr.setRequestHeader("Content-type", "application/json");
            xhr.send(data);
        }
    }

    clearRecords(meid) {
        var action = "CLEARRECORDS";
        var data = "";

        data = '{"gu":' + window.globalGU + ', "action":"' + action + '", "meid":' + meid + '}';

        var xhr = new XMLHttpRequest();
        xhr.open('PATCH', '/api/SyncGraphics/SetClock/' + meid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    toggleLocator() {
        var xhr = new XMLHttpRequest();
        var data = '{"gu":' + window.globalGU + ',"mid":' + window.globalMID + ' }';
        xhr.open('POST', '/api/SyncGraphics/ToggleLocator/' + window.globalMID, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    resetRecords() {
        this.setState({ rtypes: [] });
    }
    setForceLap(lap) {
        document.getElementById("forceLap").value = lap;
    }
    showSplit(meid, heat, action, split) {
        var data = "";
        var lap = document.getElementById("forceLap").value === "" ? 0 : document.getElementById("forceLap").value;

        if (heat === 0) {
            data = '{"gu":' + window.globalGU + ', "action":"' + action + '", "meid":' + meid + ', "splitnumber":' + split + ', "lap":' + lap + ' }';
        } else {
            data = '{"gu":' + window.globalGU + ', "action":"' + action + '", "meid":' + meid + ',"heat":' + heat + ', "splitnumber":' + split + ', "lap":' + lap + '}';
        }

        var xhr = new XMLHttpRequest();
        xhr.open('PATCH', '/api/SyncGraphics/SetClock/' + meid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    showManySplits(meid, heat, action, count) {
        var data = "";
        var lap = document.getElementById("forceLap").value === "" ? 0 : document.getElementById("forceLap").value;
        //FORCE 6 RIDERS FOR HARLEY
        count = 6;
        (function loopSplits(i) {
            setTimeout(function () {
                if (heat === 0) {
                    data = '{"gu":' + window.globalGU + ', "action":"' + action + '", "meid":' + meid + ', "splitnumber":' + i + ', "lap":' + lap + '}';
                } else {
                    data = '{"gu":' + window.globalGU + ', "action":"' + action + '", "meid":' + meid + ',"heat":' + heat + ', "splitnumber":' + i + ', "lap":' + lap + '}';
                }

                var xhr = new XMLHttpRequest();
                xhr.open('PATCH', '/api/SyncGraphics/SetClock/' + meid, true);
                xhr.setRequestHeader("Content-type", "application/json");
                xhr.send(data);

                if (i++ < count) loopSplits(i);
            }, 250)
        })(1);
    }

    showSplitsPage(meid, lapNumber) {
        var fullscreenValue = false;
        var data = '{"gu":' + window.globalGU + ',"meid":' + meid + ',"lapNumber":' + lapNumber + ', "fullscreen": ' + fullscreenValue + '}';

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/ShowSplitPage/' + window.globalMID, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }

    clearSplit(meid, heat, action) {
        var data = "";

        if (heat == 0) {
            data = '{"gu":' + window.globalGU + ', "action":"' + action + '", "meid":' + meid + '}';
        } else {
            data = '{"gu":' + window.globalGU + ', "action":"' + action + '", "meid":' + meid + ',"heat":' + heat + '}';
        }

        var xhr = new XMLHttpRequest();
        xhr.open('PATCH', '/api/SyncGraphics/SetClock/' + meid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }

    render() {
        var currentEvent = this.props.currentEvent;
        var athleteClick = this.props.athleteClick;
        var meta = this.props.meta;
        var eventHeader = "";
        var entries = null;
        var wind = null;
        var qNote = currentEvent.QNote ? <div className="qNote">{currentEvent.QNote}</div> : null;
        var style;
        var ceRecords = this.props.records;

        currentEvent.OF = currentEvent.OF == undefined ? false : currentEvent.OF;
        currentEvent.OL = currentEvent.OL == undefined ? false : currentEvent.OL;

        if (this.props.osf && !currentEvent.OF || !this.props.osf && currentEvent.OF) {
            meta.showFlag = true;
        } else {
            meta.showFlag = false;
        }

        if (this.props.osl && !currentEvent.OL || !this.props.osl && currentEvent.OL) {
            meta.showLogo = true;
        } else {
            meta.showLogo = false;
        }

        if (currentEvent.S === "Not Started" || currentEvent.S === "Up Next") {
            eventHeader = "Start List";
            entries = currentEvent.ED ? <StartList entries={currentEvent.ED} athleteClick={athleteClick}></StartList> : <div>Entries not available</div>;
        } else if (currentEvent.S === "Complete") {
            eventHeader = "Results";
        } else if (currentEvent.S === "Reviewing") {
            eventHeader = "Standings - Finalizing";
        } else if (currentEvent.S === "Cancelled") {
            eventHeader = "Cancelled";
        } else {
            eventHeader = "In-Progress Standings";
        }

        if (currentEvent.S === "Not Started" || currentEvent.S === "Up Next" || currentEvent.S === "Cancelled") {
            entries = currentEvent.ED ? <StartList entries={currentEvent.ED} hasHeats={currentEvent.HH} athleteClick={athleteClick} meta={meta} eventType={currentEvent.E.C} meid={currentEvent.ID}></StartList> : <div>Entries not available</div>;
        } else if (currentEvent.E.C === "RUN" || currentEvent.E.C === "STRAIGHT" || currentEvent.E.C === "RELAY" || currentEvent.E.C === "XC") {
            if (!currentEvent.HR) {
                currentEvent.HR = false;
            }
            entries = currentEvent.ED ? <TrackResults currentEvent={currentEvent} athleteClick={athleteClick} meta={meta}></TrackResults> : <div>Results currently not available</div>;
        } else if (currentEvent.E.C === "HJUMP" || currentEvent.E.C === "THROW") {
            entries = currentEvent.ED ? <HFieldResults currentEvent={currentEvent} athleteClick={athleteClick} meta={meta}></HFieldResults> : <div>Results currently not available</div>;
        }
        else if (currentEvent.E.C === "VJUMP") {
            entries = currentEvent.ED ? <VFieldResults currentEvent={currentEvent} athleteClick={athleteClick} meta={meta}></VFieldResults> : <div>Results currently not available</div>;
        } else if (currentEvent.E.C == "MULTI") {
            entries = currentEvent.ED ? <MultiResults currentEvent={currentEvent} athleteClick={athleteClick} meta={meta} eventType={currentEvent.L}></MultiResults> : <div>Results currently not available</div>;
        }

        var lapButtons = [];

        var lapCount = currentEvent.hasOwnProperty("TLN") ? currentEvent.TLN : currentEvent.hasOwnProperty("TL") ? currentEvent.TL : 0;

        if (lapCount>1) {
            for (var x = lapCount - 1; x > 0; x--) {
                lapButtons.push(<button className="btn btn-secondary" key={"L2G" + x} onClick={this.showL2G.bind(this, currentEvent.ID, 0, "L2G", x)}>{x} Laps to Go</button>);
            }
        }


        var listButtons = [];
        var splitList = currentEvent.hasOwnProperty("SL") ? currentEvent.SL.split(",") : [];
        if (currentEvent.hasOwnProperty("TL")) {
            for (var x = 0; x < currentEvent.TL; x++) {
                let lapClass = x == currentEvent.CL - 1 ? "btn-success" : "btn-outline-secondary";
                //listButtons.push(<button className={"btn btn-sm btn-split " + lapClass} key={"SPLITPAGE" + x} onClick={this.showSplitsPage.bind(this, currentEvent.ID, x + 1)}>{splitList[x]}-{x+1}</button>);
                listButtons.push(<button className={"btn btn-sm btn-split " + lapClass} key={"SPLITPAGE" + x} onClick={this.setForceLap.bind(this, x+1)}>{splitList[x]}-{x + 1}</button>);
            }
        }



        

        if (currentEvent.hasOwnProperty("HH")) {
            //if (currentEvent.hasOwnProperty("HH") && currentEvent.E.T !== "F") {


            //listButtons.push(<button key={"lbPrevRes"} className='btn btn-secondary-outline' onClick={() => this.showPrevious(currentEvent.ID)}>Previous<br />Result</button>);

            listButtons.push(<button key={"lbHLoc"} className='btn btn-secondary' onClick={() => this.showLocator(currentEvent.ID)}>Event<br />Locator</button>);
           
            listButtons.push(<button key="btnHideClock" type="button" className='btn btn-outline-danger' onClick={this.setClock.bind(this, currentEvent.ID, 0, "HIDECLOCK")}>Clock Hide</button>);
            listButtons.push(<button key="btnShowClock" type="button" className='btn btn-outline-success' onClick={this.setClock.bind(this, currentEvent.ID, 0, "SHOWCLOCK")}>Clock Show</button>);
            var maxHeat = _.max(currentEvent.ED, function (e) { return e.HSF; }).HSF;
            if (maxHeat === undefined) {
                maxHeat = 1;
            }

            for (var h = 1; h <= maxHeat; h++) {
                var ed = _.filter(currentEvent.ED, function (e) { return e.HSF == h; });

                var outline = currentEvent.CH == h ? "" : "outline-";

                var eCount = ed.length;
                var pages = Math.ceil(eCount/ lines);
                listButtons.push(<button key={"lbHSetLocator" + h} className={"btn btn-" + outline + "secondary"} onClick={this.showLocator.bind(this, currentEvent.ID, h)}>Heat {h}<br />Locator</button>);
                listButtons.push(<button key={"lbHSetClock" + h} className={"btn btn-" + outline + "warning"} onClick={this.setClock.bind(this, currentEvent.ID, h, "SET")}>Heat {h}<br />Set Clock</button>);
                for (x = 1; x <= pages; x++) {
                    listButtons.push(<button key={"lbH" + h + "SP" + x} className={"btn btn-" + outline + "danger"} onClick={this.showStartList.bind(this, currentEvent.ID, h, x)}>Heat {h} Start<br />Page {x}</button>);
                }

                if (globalMID === 1454 || globalMID === 1567 || globalMID === 2328) {
                    for (x = 1; x <= pages; x++) {
                        listButtons.push(<button key={"lbH" + h + "SPS" + x} className={"btn btn-" + outline + "info"} onClick={this.showStartListSlab.bind(this, currentEvent.ID, h, x)}>Heat {h} Start<br />Slab {x}</button>);
                    }
                }

                for (x = 1; x <= pages; x++) {
                    listButtons.push(<button key={"lbH" + h + "R" + x} className={"btn btn-" + outline + "success"} onClick={this.showResults.bind(this, currentEvent.ID, h, x)}>Heat {h} Results<br />Page {x}</button>);
                }

                if (currentEvent.hasOwnProperty("HR"))
                    if (currentEvent.HR)
                        listButtons.push(<button key={"lb" + h + "RT"} className='btn btn-secondary' onClick={this.showReactime.bind(this, currentEvent.ID, h)}>Heat {h}<br />Reactime</button>);

                

            }
        } else {
            var ed = _.map(currentEvent.ED, function (value, index) {
                return [value];
            });
            var edr = _.map(currentEvent.ED, function (value, index) {
                if (value.hasOwnProperty("MM") || value.hasOwnProperty("DNF") || value.hasOwnProperty("DQ")) return [value];
            });
            var eCount = ed.length;
            var erCount = edr.length;
            var pages = Math.ceil(eCount/ lines);
            var pagesr = Math.ceil(erCount/ lines);
            listButtons.push(<button key={"lbLoc"} className='btn btn-secondary' onClick={this.showLocator.bind(this, currentEvent.ID, 0)}>Event<br />Locator</button>);
            

            listButtons.push(<button key="btnHideClock" type="button" className='btn btn-outline-danger' onClick={this.setClock.bind(this, currentEvent.ID, 0, "HIDECLOCK")}>Clock Hide</button>);
            listButtons.push(<button key="btnShowClock" type="button" className='btn btn-outline-success' onClick={this.setClock.bind(this, currentEvent.ID, 0, "SHOWCLOCK")}>Clock Show</button>);

            if (currentEvent.E.T !== "F") {
                listButtons.push(<button key="lbSetClock" className='btn btn-warning' onClick={this.setClock.bind(this, currentEvent.ID, 0, "SET")}>Set<br />Clock</button>);
            }
            for (x = 1; x <= pages; x++) {
                listButtons.push(<button key={"lbSP" + x} className='btn btn-danger' onClick={this.showStartList.bind(this, currentEvent.ID, 0, x)}>Start<br />Page {x}</button>);
            }
            if (globalMID === 1454 || globalMID === 1567) {

                for (x = 1; x <= pages; x++) {
                    listButtons.push(<button key={"lbSPS" + x} className='btn btn-info' onClick={this.showStartListSlab.bind(this, currentEvent.ID, 0, x)}>Start<br />Slab {x}</button>);
                }
            }

            listButtons.push(<button key={"lbKC"} className={"btn btn-warning"} onClick={this.showKeyCompetitors.bind(this, currentEvent.ID, 0, 1)}>Key<br />Competitors</button>);

            for (x = 1; x <= pagesr; x++) {
                listButtons.push(<button key={"lbR" + x} className='btn btn-success' onClick={this.showResults.bind(this, currentEvent.ID, 0, x)}>Results<br />Page {x}</button>);
            }
            if (currentEvent.hasOwnProperty("HR"))
                if(currentEvent.HR)
                    listButtons.push(<button key={"lbRT"} className='btn btn-secondary' onClick={this.showReactime.bind(this, currentEvent.ID, 0)}>Show<br />Reactime</button>);

           
        }

        var ed = _.map(currentEvent.ED, function (value, index) {
            if (value.hasOwnProperty("MM"))
                return [value];
        });
        var eCount = ed.length;
        var pages = Math.ceil(eCount/ lines);
        if (pages > 6) pages = 6;
        for (x = 1; x <= pages; x++) {
            listButtons.push(<button key={"fp" + x} className='btn btn-outline-info' onClick={this.showResults.bind(this, currentEvent.ID, 0, x)}>Standings<br />Full - {x}</button>);
        }
        listButtons.push(<button key={"fpTop3"} className='btn btn-info' onClick={this.showTopResults.bind(this, currentEvent.ID, 3)}>Standings<br />Top 3</button>);
        listButtons.push(<button key={"fpTop4"} className='btn btn-info' onClick={this.showTopResults.bind(this, currentEvent.ID, 4)}>Standings<br />Top 4</button>);
        listButtons.push(<button key={"fpTop5"} className='btn btn-info' onClick={this.showTopResults.bind(this, currentEvent.ID, 5)}>Standings<br />Top 5</button>);
        listButtons.push(<button key={"fpTop6"} className='btn btn-info' onClick={this.showTopResults.bind(this, currentEvent.ID, 6)}>Standings<br />Top 6</button>);
        listButtons.push(<button key={"fpTop7"} className='btn btn-info' onClick={this.showTopResults.bind(this, currentEvent.ID, 7)}>Standings<br />Top 7</button>);
        listButtons.push(<button key={"fpTop8"} className='btn btn-info' onClick={this.showTopResults.bind(this, currentEvent.ID, 8)}>Standings<br />Top 8</button>);
        listButtons.push(<button key={"fpTop9"} className='btn btn-info' onClick={this.showTopResults.bind(this, currentEvent.ID, 9)}>Standings<br />Top 9</button>);
        listButtons.push(<button key={"fpTop10"} className='btn btn-info' onClick={this.showTopResults.bind(this, currentEvent.ID, 10)}>Standings<br />Top 10</button>);

        
        //listButtons.push(<button key={"lbRTBS"} className='btn btn-success' onClick={this.toggleTiebreaker.bind(this, true)}>Show<br/>Tiebreaker</button>);
        //listButtons.push(<button key={"lbRTBH"} className='btn btn-success' onClick={this.toggleTiebreaker.bind(this, false)}>Hide<br />Tiebreaker</button>);

        listButtons.push(<button key="lbT2B" className='btn btn-secondary' onClick={this.setClock.bind(this, currentEvent.ID, 0, "T2B")}>Toggle<br />Time to Beat</button>);
        listButtons.push(<button key="lbT2Q" className='btn btn-secondary' onClick={this.setClock.bind(this, currentEvent.ID, 0, "T2Q")}>Toggle<br />Time to Qualify</button>);

        //added for DL
        //listButtons.push(<button key={"lbHLocToggle"} className='btn btn-secondary' onClick={() => this.toggleLocator()}>Toggle<br />Locator Record</button>);
        listButtons.push(<button key={"lbWLocToggle"} className='btn btn-secondary' onClick={this.showRecordChip.bind(this, currentEvent.ID, "WL")}>Toggle<br />World Lead</button>);
        listButtons.push(<button key={"lbWRLocToggle"} className='btn btn-secondary' onClick={this.showRecordChip.bind(this, currentEvent.ID, "WR")}>Toggle<br />World Record</button>);
        listButtons.push(<button key={"lbARLocToggle"} className='btn btn-secondary' onClick={this.showRecordChip.bind(this, currentEvent.ID, "NR-USA")}>Toggle<br />American Record</button>);
        //listButtons.push(<button key={"lbMRLocToggle"} className='btn btn-secondary' onClick={this.showRecordChip.bind(this, currentEvent.ID, "MR")}>Toggle<br />Meet Record</button>);
        //end added for DL

        //if (currentEvent.E.T === "F")
        //    listButtons.push(<button key={"lb" + h + "SB"} className='btn btn-secondary' onClick={this.showScoreBug.bind(this, currentEvent.ID)}>NBC<br />Scorebug</button>);
        var recordsButtons = [];
       
//if (currentEvent.E.T !== "F") {
 if (ceRecords !== null) {
            var e = ceRecords;
            for (var i = 0, len = e.length; i < len; i++) {
                var rtype = e[i].T === "NR" || e[i].T === "SR" ? e[i].T + "-" + e[i].A : e[i].T;
                var btnClass = this.state.rtypes.includes(rtype) ? "btn-info record-select" : "btn-outline-secondary";

                recordsButtons.push(<button type='button' onClick={this.setRecord.bind(this, currentEvent.ID, rtype)} className={"btn " + btnClass}> {rtype}<br />{e[i].M}</button>);
            }

            recordsButtons.push(<button type="button" onClick={this.resetRecords.bind(this)} className="btn btn-outline-secondary">Reset<br />Selection</button>);
            recordsButtons.push(<button type="button" onClick={this.showRecords.bind(this, currentEvent.ID)} className="btn btn-outline-success">Show<br />Records</button>);
            recordsButtons.push(<button type="button" onClick={()=>window.clearAll()} className="btn btn-outline-danger">Clear<br />Slab Records</button>);
            recordsButtons.push(<button type="button" onClick={this.clearRecords.bind(this, currentEvent.ID)} className="btn btn-outline-danger">Hide<br />Clock Records</button>);

        }
//}

        var splitButtons = [];
        if (currentEvent.hasOwnProperty("HSp")) {
            var xx = currentEvent.E.C == "XC" || meetType === "Road" || meetType == "Stage" || currentEvent.EID == "20K RW" ? 9 : 7;
            for (x = 1; x < xx; x++) {
                splitButtons.push(<button className="btn btn-secondary" onClick={this.showSplit.bind(this, currentEvent.ID, currentEvent.CH, 'SPLIT', x)}>Split {x}</button>);
            }

            if (currentEvent.E.C == "XC" || meetType == "Road" || meetType == "Stage" || currentEvent.EID == "20K RW") {
                splitButtons.push(<button className="btn btn-outline-info" onClick={this.showManySplits.bind(this, currentEvent.ID, currentEvent.CH, 'SPLIT', 8)}>Show & Hold 8</button>);
            } else {
                splitButtons.push(<button className="btn btn-outline-info" onClick={this.showManySplits.bind(this, currentEvent.ID, currentEvent.CH, 'SPLIT', 5)}>Show & Fade 5</button>);
            }

            splitButtons.push(<button className="btn btn-outline-success" onClick={() => window.enableSplit(true)}>Enable Splits</button>);
            splitButtons.push(<button className="btn btn-outline-success" onClick={() => window.enableSplit(false)}>Disable Splits</button>);
            splitButtons.push(<button className="btn btn-outline-danger" onClick={this.clearSplit.bind(this, currentEvent.ID, 0, 'CLEARSPLIT')}>Clear Split(s)</button>);

            splitButtons.push(<button className="btn btn-outline-success" onClick={() => window.toggleShowSplit(true)}>NBC Splits On</button>);
            splitButtons.push(<button className="btn btn-outline-danger" onClick={() => window.toggleShowSplit(false)}>NBC Splits Off</button>);
            splitButtons.push(<button className="btn btn-outline-success" onClick={() => window.toggleSplit(true)}>Auto Splits On</button>);
            splitButtons.push(<button className="btn btn-outline-danger" onClick={() => window.toggleSplit(false)}>Auto Splits Off</button>);

            splitButtons.push(<button className="btn btn-outline-success" onClick={() => window.toggleIsolynx(true)}>Isolynx On</button>);
            splitButtons.push(<button className="btn btn-outline-danger" onClick={() => window.toggleIsolynx(false)}>Isolynx Off</button>);

            splitButtons.push(<button className="btn btn-outline-success" onClick={() => window.showSpeed(true)}>Speed On</button>);
            splitButtons.push(<button className="btn btn-outline-danger" onClick={() => window.showSpeed(false)}>Speed Off</button>);

            splitButtons.push(<button className="btn btn-outline-danger" onClick={() => window.turnoffSidebar(false)}>Sidebar Off</button>);

            splitButtons.push(<span>Force Lap: <input className="" id="forceLap" /></span>);

        }

        if (currentEvent.hasOwnProperty("CC")) {
            splitButtons.push(<button className="btn btn-outline-danger" onClick={() => window.clearCC(1)}>Clear CC</button>);
        }

        if (currentEvent.hasOwnProperty("CC2")) {
            splitButtons.push(<button className="btn btn-outline-danger" onClick={() => window.clearCC(2)}>Clear CC2</button>);
        }

        if (currentEvent.hasOwnProperty("CRND")) {
            splitButtons.push(<button className="btn btn-outline-danger" onClick={() => window.clearCRND(1)}>Clear CRND</button>);
        }

        if (currentEvent.hasOwnProperty("CRND2")) {
            splitButtons.push(<button className="btn btn-outline-danger" onClick={() => window.clearCRND(2)}>Clear CRND2</button>);
        }

        if (currentEvent.hasOwnProperty("CHT")) {
            splitButtons.push(<button className="btn btn-outline-danger" onClick={() => window.clearCHT(1)}>Clear CHT</button>);
        }

        if (currentEvent.hasOwnProperty("CHT2")) {
            splitButtons.push(<button className="btn btn-outline-danger" onClick={() => window.clearCHT(2)}>Clear CHT2</button>);
        }

        return (
            <div id="result" className="tabContent">
                <div className="statusButtons btn-group" style={{ marginTop: "15px" }} role="group">
                    <button className={"btn btn-status btn-outline-danger" + (currentEvent.S == "Not Started" ? " active" : "")} role='button' onClick={() => this.updateStatus(currentEvent.ID, "Not Started")}>Not Started</button>
                    <button className={"btn btn-status btn-outline-warning" + (currentEvent.S == "Up Next" ? " active" : "")} role='button' onClick={() => this.updateStatus(currentEvent.ID, "Up Next")}>Up Next</button>
                    <button className={"btn btn-status btn-outline-success" + (currentEvent.S == "Live" ? " active" : "")} role='button' onClick={() => this.updateStatus(currentEvent.ID, "Live")}>Live</button>
                    <button className={"btn btn-status btn-outline-info" + (currentEvent.S == "Reviewing" ? " active" : "")} role='button' onClick={() => this.updateStatus(currentEvent.ID, "Reviewing")}>Reviewing</button>
                    <button className={"btn btn-status btn-outline-primary" + (currentEvent.S == "Complete" ? " active" : "")} role='button' onClick={() => this.updateStatus(currentEvent.ID, "Complete")}>Complete</button>
                    <button className={"btn btn-status btn-outline-danger" + (currentEvent.S == "Cancelled" ? " active" : "")} role='button' onClick={() => this.updateStatus(currentEvent.ID, "Cancelled")}>Cancelled</button>
                </div>
                <hr />
                <div className="btn-group" role="group">
                    <button onClick={() => this.syncHytek(currentEvent.ID)} className="btn btn-outline-secondary btn" role="button">Sync Hytek</button>
                    <button onClick={() => this.readLynx(currentEvent.ID)} className="btn btn-outline-secondary btn" role="button">Read Lynx</button>
                    <button onClick={() => this.postOnline(currentEvent.ID)} className="btn btn-outline-secondary btn" role="button">Post Online</button>

                    <a href={"/MeetEvents/Edit/" + currentEvent.ID} className="btn btn-outline-info btn" role="button" target="_blank">Edit</a>
                </div>
                <hr/>
                <div className="recordButtons btn-group" role="group" style={{ flexWrap: "wrap" }}>
                    {recordsButtons}
                </div>
                <hr />

                <div className="lapButtons btn-group" role="group" style={{ flexWrap: "wrap" }}>
                    {lapButtons}
                </div>
                <hr />
                <div className="splitButtons btn-group" role="group" style={{ flexWrap: "wrap" }}>
                    {splitButtons}
                </div>
                <hr />
                <div className="listButtons btn-group" role="group" style={{ flexWrap: "wrap" }}>
                    {listButtons}
                </div>
                <hr />
                <div role="group" style={{ flexWrap: "wrap" }}>
                    <div>ID w/Mark Note: <input name="markAdd" id="markAdd" className="markAdd" />
                        &nbsp;&nbsp;&nbsp;&nbsp;
                    </div>

                    <div>
                        <input type="checkbox" name="fullscreen" id="fullscreen" /> Fullscreen Start/Result Page &nbsp;&nbsp;&nbsp;&nbsp;
                    </div>
                    <div>Leaderboard: <input name="lbBIBs" id="lbBIBs" className="markAdd" placeholder="1,3,5..." /><input name="lbHeader" id="lbHeader" className="markAdd" placeholder="Leaders at X Mile" />  <input name="lbShowPlace" id="lbShowPlace" type="checkbox" /> Show Place <button className={"btn btn-status btn-outline-info"} role='button' onClick={() => this.showLeaderboard(currentEvent.ID)}>Show Leaderboard</button></div>
                </div>
                <hr />

                <h3><span id="eventResultHeader">{eventHeader}</span>
                </h3>
                {qNote}
                {wind}
                {entries}
            </div>
        );
    }
}





class StartList extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        var meta = this.props.meta;
        var entries = this.props.entries;
        var hasHeats = this.props.hasHeats;
        var eventType = this.props.eventType;
        var athleteClick = this.props.athleteClick;
        var meid = this.props.meid;

        var entryArray = [];
        var heatArray = [];

        for (var e in entries) {
            entryArray.push(entries[e]);
        }

        entryArray.sort(function (a, b) {
            var aInt = parseInt(a.LP);
            var bInt = parseInt(b.LP);
            if (aInt < bInt)
                return -1;
            if (aInt > bInt)
                return 1;
            return 0;
        });

        if (hasHeats) {
            heatArray = entryArray.reduce((heats, e) => {
                var heat = e.HSF || 0;
                (heats[heat] = heats[heat] || []).push(e);
                return heats;
            }, []);
            var heatStarts = heatArray.map(function (h, i) { return <StartListTable key={"sl" + meid + "-" + i} entryArray={h} meta={meta} hsf={i} hasHeats={hasHeats} eventType={eventType} athleteClick={athleteClick} /> });
            return <div>{heatStarts}</div>;
        }

        else {
            return <StartListTable key={"sl" + meid} entryArray={entryArray} eventType={eventType} meta={meta} hasHeats={hasHeats} athleteClick={athleteClick} />;
        }



    }
}

class StartListTable extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        var meta = this.props.meta;
        var athleteClick = this.props.athleteClick;
        var entryArray = this.props.entryArray;
        var eventType = this.props.eventType;
        var heatWord = eventType === "RUN" || eventType === "STRAIGHT" || eventType === "RELAY" ? "Heat" : "Flight";
        var heatHead = null;
        if (this.props.hasHeats) {
            if (this.props.hsf === 0) {
                heatHead = <tr className="heatName"><th colSpan="4">Pending {heatWord} Assignment</th></tr>;
            } else {
                heatHead = <tr className="heatName"><th colSpan="4">{heatWord} {this.props.hsf}</th></tr>;
            }
        }

        return <table className="raceResults">
            <thead>
                {heatHead}
                <tr><th className="lnpos">Ln/Pos</th><th>&nbsp;</th><th>Athlete</th></tr>
            </thead>
            <tbody>{entryArray.map(function (e) { return <StartListRow key={"slr" + e.BIB} entry={e} eventType={eventType} showFlag={meta.showFlag} showLogo={meta.showLogo} showAff={meta.showAff} athleteClick={athleteClick} /> })}</tbody>
        </table>;
    }
}

class StartListRow extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        var entry = this.props.entry;
        var flag = null, aff = null;
        var athleteClick = this.props.athleteClick;
        var eventType = this.props.eventType;

        if (this.props.showFlag) {
            flag = entry.A.CC ? <div className="aff"><img src={'/img/flags/' + entry.A.CC + '.png'} />{entry.A.CC}</div> : null;

        }
        if (this.props.showAff) {
            if (entry.TN) {
                if (this.props.showLogo) {
                    flag = entry.TC ? <div className="aff"><img src={'/img/logos/' + entry.TC + '.png'} /></div> : null;

                }
                var year = entry.Y ? "[" + entry.Y + "]" : null;
                aff = entry.TN ? <div className="affiliation">{entry.TN} {year}</div> : null;
            } else {
                if (this.props.showLogo) {
                    flag = entry.A.TC ? <div className="aff"><img src={'/img/logos/' + entry.A.TC + '.png'} /></div> : null;

                }
                aff = entry.A.A ? <div className="affiliation">{entry.A.A}</div> : null;
            }
        }

        var btnRelayNames = eventType == "RELAY" ? <button onClick={() => window.showRelayNames(entry.ID, false, false, -1)} className='btnAthleteID'>Relay<br />Names</button> : null;

        var kc = null;
        if (entry.hasOwnProperty("KC")) {
            kc = <span className="kc">{entry.KC}</span>;
        }
        if (entry.RRD) {
            var year = entry.Y ? "[" + entry.Y + "]" : null;
            aff = <div className="affiliation">{year} {entry.RRD.filter(function (rr) { return rr.L > 0 && rr.L <= 4 }).map(function (rr) { return rr.A ? rr.A.N ? rr.A.N : "" : "" }).join(", ")}</div>;
        }
        return (
            <tr>
                <td>{entry.LP}</td>
                <td style={{ width: '1px', whiteSpace: 'nowrap' }}>{btnRelayNames}<button className='btnAthleteID' onClick={() => window.showAthlete(entry.ID, false, false, 0,0, false)}>ID<br />Simple</button>
                    <button className='btnAthleteID' onClick={() => window.showAthlete(entry.ID, false, false,-1)}>ID<br />w/PBSB</button>
                    <button className='btnAthleteID' onClick={() => window.showAthlete(entry.ID, false, false, 1)}>ID<br />w/Highlight</button>

                    <button className='btnAthleteID' onClick={() => window.showRowingCrew(entry.ID, false, false, 1)}>Rowing<br />Crew</button>

                    <button className='btnAthleteID' onClick={() => window.showAthlete(entry.ID, false, true)}>ID<br />w/Ln-Pos</button><button className='btnAthleteID' onClick={() => window.showLine2(entry.ID)}>Start<br />Line 2</button></td>

                <td className="athlete bold" onClick={() => athleteClick(entry.AID)}>{flag}<span>{entry.A.N}{kc}</span>{aff}</td>
            </tr>
        );

    }
}

class TrackResults extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {

        var meta = this.props.meta;
        var athleteClick = this.props.athleteClick;

        var entries = this.props.currentEvent.ED;
        var hasHeats = this.props.currentEvent.HH;
        var hasSections = this.props.currentEvent.HSec;
        var eventType = this.props.currentEvent.E.C;
        var currentHeat = this.props.currentEvent.CH;
        var currentLap = this.props.currentEvent.CL;
        var splitList = this.props.currentEvent.SL;
        var bubble = this.props.currentEvent.BC;
        var hasReact = this.props.currentEvent.HR;
        var hasWind = this.props.currentEvent.HW;
        var status = this.props.currentEvent.S;

        var entryArray = [];
        var heatArray = [];
        var flip = false;


        for (var e in entries) {
            entryArray.push(entries[e]);
        }


        entryArray.sort(sortPlaces);

        var tableClass = "raceResults";
        var windRow = null;
        var reactTH = hasReact ? <th className="center">React</th> : null;
        var heatTH = hasHeats ? <th className="center">Heat</th> : null;
        var windTH = hasHeats && hasWind ? <th className="center">Wind</th> : null;
        var splits = [];
        var splitReverse = false;
        if (splitList) {
            splits = splitList.split(",");
            if (splits.length > 4) {
                tableClass += "";
            }
            var cl = currentHeat > 1 ? splits.length : currentLap;
            entryArray.sort(function (a, b) {

                var aPlace;
                var bPlace;
                if (a.P)
                    aPlace = a.P;
                else if (a.DNS)
                    aPlace = 999999;
                else if (a.DQ)
                    aPlace = 999995;
                else if (a.DNF)
                    aPlace = 999990;
                else if (a.SPD)
                    aPlace = a.SPD[cl] ? a.SPD[cl].P : undefined;
                else
                    if (a.sortPlace)
                        aPlace = a.sortPlace;
                    //aPlace = a.HSF * 1000 + a.LP;
                    else
                        aPlace = 999999;

                if (b.P)
                    bPlace = b.P;
                else if (b.DNS)
                    bPlace = 999999;
                else if (b.DQ)
                    bPlace = 999995;
                else if (b.DNF)
                    bPlace = 999990;
                else if (b.SPD)
                    bPlace = b.SPD[cl] ? b.SPD[cl].P : undefined;
                else
                    if (b.sortPlace)
                        bPlace = b.sortPlace;
                    //bPlace = b.HSF * 1000 + b.LP;
                    else
                        bPlace = 999999;

                if (cl > 1) {
                    if ((!aPlace || aPlace === 9999) && a.SPD[cl - 1]) aPlace = 500 + a.SPD[cl - 1].P; else if ((!aPlace || aPlace === 9999) && a.sortPlace) aPlace = a.sortPlace;
                    if ((!bPlace || bPlace === 9999) && b.SPD[cl - 1]) bPlace = 500 + b.SPD[cl - 1].P; else if ((!bPlace || bPlace === 9999) && b.sortPlace) bPlace = b.sortPlace;
                }

                if (!aPlace)
                    return 1;
                if (!bPlace)
                    return -1;
                if (aPlace < bPlace)
                    return -1;
                if (aPlace > bPlace)
                    return 1;
                return 0;
            });

            //changing this.props.currentLap to cl to allow for all splits on compiled results when heats
            splits.splice(cl, splits.length - cl);
            if (status == "Live" || status == "Reviewing") {
                splits.reverse();
                splitReverse = true;
            }
        }

        if (entryArray[0].W !== undefined && entryArray[0].W !== "" && !hasHeats && hasWind) {
            var windRowClass = entryArray[0].W > 2 ? "resultWind aided" : "resultWind";
            windRow = <tr><th colSpan="4" className={windRowClass}>Wind: {entryArray[0].W.toFixed(1)} m/s</th></tr>;
        }
        var createEntry = function (entry, index) {
            var reactTD = null;
            var heatTD = null;
            var windTD = null;
            var tiebreak = null;
            var tsPoints = null;
            if (entry.hasOwnProperty("PT")) {
                tsPoints = entry.PT == 1 ? <div className="small tsPoints">{entry.PT} Pt</div> : <div className="small tsPoints">{entry.PT} Pts</div>;
            }

            var kc = null;
            if (entry.hasOwnProperty("KC")) {
                kc = <span className="kc">{entry.KC}</span>;
            }

            if (hasReact) {
                if (entry.RT)
                    reactTD = <td className="center">{entry.RT.toFixed(3)}</td>;
                else
                    reactTD = <td className="center"></td>;
            }

            if (hasHeats) {
                if (entry.HP) {
                    heatTD = <td className="center">{entry.HSF} ({entry.HP})</td>;
                } else {
                    heatTD = <td className="center">{entry.HSF}</td>;
                }

                if (hasWind) {
                    if (entry.W !== undefined && entry.W !== "") {
                        var windTDClass = entry.W > 2 ? "center aided" : "center";
                        windTD = <td className={windTDClass}>{entry.W.toFixed(1)} m/s</td>;
                    } else {
                        windTD = <td></td>;
                    }
                }
            }
            if (entry.MTB) {
                tiebreak = <div className="small">{entry.MTB}</div>;
            }

            var current = null;

            if (entry.ID === bubble) {
                current = "bubble";
            }


            var place = null, flag = null, aff = null;

            if (meta.showFlag) {
                flag = entry.A.CC ? <div className="aff"><img src={'/img/flags/' + entry.A.CC + '.png'} />{entry.A.CC}</div> : null;

            }
            if (meta.showAff) {
                if (entry.TN) {
                    if (meta.showLogo) {
                        flag = entry.TC ? <div className="aff"><img src={'/img/logos/' + entry.TC + '.png'} /></div> : null;

                    }
                    var year = entry.Y ? "[" + entry.Y + "]" : null;
                    aff = entry.TN ? <div className="affiliation">{entry.TN} {year}</div> : null;
                } else {
                    if (meta.showLogo) {
                        flag = entry.A.TC ? <div className="aff"><img src={'/img/logos/' + entry.A.TC + '.png'} /></div> : null;

                    }
                    aff = entry.A.A ? <div className="affiliation">{entry.A.A}</div> : null;
                }
            }

            if (entry.RRD) {
                var year = entry.Y ? "[" + entry.Y + "]" : null;
                aff = <div className="affiliation">{year} {entry.RRD.filter(function (rr) { return rr.L > 0 && rr.L <= 4 }).map(function (rr) { return rr.A ? rr.A.N ? rr.A.N : "" : "" }).join(", ")}</div>;
            }

            if (entry.DNS || entry.P === 999) place = "DNS";
            else if (entry.DNF || entry.P === 997) place = "DNF";
            else if (entry.DQ || entry.P === 996) place = "DQ";
            else if (entry.P === 998) place = "FS";
            else if (entry.P) place = entry.P;

            var dqr = null;
            if (entry.hasOwnProperty("DQR")) {
                if (entry.DQR == "FS") place = "FS";
                else dqr = <small>[{entry.DQR}]</small>
            }

            var multiPoints = null;
            if (entry.hasOwnProperty('MP')) {
                multiPoints = <span className="multipoints">{entry.MP} <small>{entry.MPST} ({entry.MPSTP})</small></span>;
            }

            var btnAthleteCard = meetType === "Road" || meetType === "XC" ? <button onClick={() => window.showCard(entry.ID, "athleteCard")} className='btnAthleteID'>ID<br />Card</button> : null;
            var btnSplitCard = meetType === "Road" || meetType === "XC" ? <button onClick={() => window.showCard(entry.ID, "athleteSplit")} className='btnAthleteID'>Split<br />Card</button> : null;
            var btnPaceCard = meetType === "Road" || meetType === "XC" ? <button onClick={() => window.showCard(entry.ID, "athletePace")} className='btnAthleteID'>Pace<br />Card</button> : null;


            if (!hasHeats || place !== null)
                return (
                    <tr key={entry.BIB} className={current}>
                        <td className="bold">{place}</td>
                        <td style={{ width: '1px', whiteSpace: 'nowrap' }}><button className='btnAthleteID' onClick={() => window.showAthlete(entry.ID, true, false)}>ID<br />w/Mark</button> <button className='btnAthleteID' onClick={() => window.showAthlete(entry.ID, false, true)}>ID<br />w/Ln-Pos</button><button className='btnAthleteID' onClick={() => window.showAthlete(entry.ID, false, false, 0,0, false)}>ID<br />Simple</button>
                            <button className='btnAthleteID' onClick={() => window.showAthlete(entry.ID, false, false, -1)}>ID<br />w/PBSB</button>
                            <button className='btnAthleteID' onClick={() => window.showRowingCrew(entry.ID, false, false, 1)}>Rowing<br />Crew</button>
                            <button className='btnAthleteID' onClick={() => window.showAthlete(entry.ID, false, false, 1)}>ID<br />w/Highlight</button>
                           
                            {btnAthleteCard}
                            {btnSplitCard}
                            {btnPaceCard} &nbsp;&nbsp;&nbsp;<button className='btnAthleteID' onClick={() => window.showLine2(entry.ID)}>Start<br />Line 2</button></td>

                        <td className="athlete bold">{flag}<span>{entry.A.N}{kc}</span>{aff}</td>
                        <td className="mark right bold">{entry.M} {multiPoints}{entry.Q} {tiebreak}{dqr} {tsPoints}</td>
                        {reactTD}
                        {splits.map(function (split, i) {
                            var ls = "-", mv = null;
                            var iPos = splitReverse ? splits.length - i : i + 1;
                            if (entry.SPD) {
                                if (entry.SPD[iPos]) {
                                    if (entry.SPD[iPos].P !== 9999) {
                                        if (iPos > 1) {
                                            //ls = entry.SPD[iPos].LS.includes("|") ? null : entry.SPD[iPos].LS;
                                            if (entry.SPD[iPos].M > 0)
                                                mv = <span className="up">{entry.SPD[iPos].M}</span>;
                                            else if (entry.SPD[iPos].M < 0)
                                                mv = <span className="down">{entry.SPD[iPos].M}</span>;
                                            else if (entry.SPD[iPos].M === 0)
                                                mv = <span className="same"></span>;
                                        }
                                        return <td key={entry.BIB + "-S" + (iPos)} className="center split">
                                            <div>{entry.SPD[iPos].CS}</div>
                                            <div className="small">{ls}</div>
                                            <div className="small">Pl: {entry.SPD[iPos].P} {mv}</div>
                                        </td>;
                                    } else {
                                        return <td key={entry.BIB + "-S" + (iPos)} className="center split"></td>;
                                    }
                                } else {
                                    return <td key={entry.BIB + "-S" + (iPos)} className="center split"></td>;
                                }
                            } else {
                                return <td key={entry.BIB + "-S" + (iPos)} className="center split"></td>;
                            }
                        })}
                        {windTD}
                        {heatTD}
                        <td className="center">{entry.LP}</td>
                    </tr>
                ); else
                return null;
        };

        var heatbyheatHeading = null;

        if (hasHeats) {
            heatArray = entryArray.reduce((heats, e) => {
                var heat = e.HSF || 0;
                (heats[heat] = heats[heat] || []).push(e);
                if ('P' in e) heats[heat].HasPlaces = true;
                return heats;
            }, []);

            var heatStarts = heatArray.map(function (h, i) {
                if (h["HasPlaces"])
                    return <div><HeatResultTable key={"hhrt-" + i} entryArray={h} meta={meta} hsf={i} hasHeats={hasHeats} hasWind={hasWind} eventType={eventType} /></div>
                else
                    return <div><StartListTable key={"hsrt-" + i} entryArray={h} meta={meta} hsf={i} hasHeats={hasHeats} eventType={eventType} /></div>
            });

            heatbyheatHeading = hasSections ? <h3>Section-by-Section</h3> : <h3>Heat-by-Heat</h3>

        }

        var currentHeatTable = null;
        var compiledHead = null;
        if (hasHeats && currentHeat) {
            currentHeatTable = <HeatTrackResults currentEvent={this.props.currentEvent} athleteClick={athleteClick} meta={meta} />;
            compiledHead = <h3>Compiled Results</h3>;
        }

        return <div className="resultsDiv">
            {currentHeatTable}
            {compiledHead}
            <table className={tableClass}>
                <thead>
                    {windRow}
                    <tr><th>Place</th><th></th><th>Athlete</th><th className='right'>Result</th>{reactTH}{splits.map(function (split) { return <th key={split + "m"} className="center">{split}</th>; })}{windTH}{heatTH}<th className="center">Ln/Pos</th></tr>
                </thead>
                <tbody>{entryArray.map(createEntry)}</tbody>
            </table>
            <div className="raceSmall heatbyheat">{heatbyheatHeading}{heatStarts}</div>
        </div>

    }
}

class HFieldResults extends React.Component {
    constructor(props) {
        super(props);
        this.state = { posSort: false };
        this.posSort = this.posSort.bind(this);
    }
    posSort() {
        this.setState({ posSort: !this.state.posSort });
    }
    render() {

        var meta = this.props.meta;
        var athleteClick = this.props.athleteClick;

        var hasHeats = this.props.currentEvent.HH;
        var entries = this.props.currentEvent.ED;
        var currentAthlete = this.props.currentEvent.CC;
        var currentAthlete2 = this.props.currentEvent.CC2;
        var bubble = this.props.currentEvent.BC;

        var entryArray = [];
        var attempts;
        for (var e in entries) {
            entryArray.push(entries[e]);
        }

        if (this.state.posSort) {
            entryArray.sort(sortPos);
        } else {
            entryArray.sort(sortPlaces);
        }

        var tableClass = "raceResults";

        var createEntry = function (entry, index) {
            var place = null, flag = null, aff = null;

            var kc = null;
            if (entry.hasOwnProperty("KC")) {
                kc = <span className="kc">{entry.KC}</span>;
            }

            var tsPoints = null
            if (entry.hasOwnProperty("PT")) {
                tsPoints = entry.PT == 1 ? <div className="small tsPoints">{entry.PT} Pt</div> : <div className="small tsPoints">{entry.PT} Pts</div>;
            }
            if (meta.showFlag) {
                flag = entry.A.CC ? <div className="aff"><img src={'/img/flags/' + entry.A.CC + '.png'} />{entry.A.CC}</div> : null;

            }
            if (meta.showAff) {
                if (entry.TN) {
                    if (meta.showLogo) {
                        flag = entry.TC ? <div className="aff"><img src={'/img/logos/' + entry.TC + '.png'} /></div> : null;

                    }
                    var year = entry.Y ? "[" + entry.Y + "]" : null;
                    aff = entry.TN ? <div className="affiliation">{entry.TN} {year}</div> : null;
                } else {
                    if (meta.showLogo) {
                        flag = entry.A.TC ? <div className="aff"><img src={'/img/logos/' + entry.A.TC + '.png'} /></div> : null;

                    }
                    aff = entry.A.A ? <div className="affiliation">{entry.A.A}</div> : null;
                }
            }

            var windBest = null;
            var current = "";
            if (entry.ID == currentAthlete || entry.ID == currentAthlete2) {
                current = "current";
            }

            if (entry.ID === bubble) {
                current += " bubble";
            }

            if (entry.DNS || entry.P === 999) place = "DNS";
            else if (entry.DNF || entry.P === 997) place = "DNF";
            else if (entry.DQ || entry.P === 996) place = "DQ";
            else if (entry.P === 998) place = null;
            else if (entry.P) place = entry.P;
            attempts = [];

            var fractions = function (m) {
                if (m)
                    return m.replace("&#188;", "\u00BC").replace("&#189;", "\u00BD").replace("&#190;", "\u00BE");
                else
                    return null;
            };

            for (var an = 1; an <= 6; an++) {
                var wind = null;
                var anplace = null;
                var english = null;
                if (entry.HAD) {
                    if (entry.HAD[an]) {
                        if (entry.HAD[an].M) {
                            var tdClass = entry.HAD[an].MM === entry.MM && entry.HAD[an].MM !== -1 ? "hAttempt best" : "hAttempt";

                            if (entry.HAD[an].W !== undefined && entry.HAD[an].W !== "" && entry.HAD[an].M !== "P") {
                                var attemptWindClass = entry.HAD[an].W > 2 ? "wind aided" : "wind";
                                wind = <div className={attemptWindClass}>{entry.HAD[an].W.toFixed(1)}</div>;
                            }
                            if (entry.HAD[an].P) {
                                if (entry.HAD[an].P !== 0 && entry.HAD[an].P !== 998)
                                    anplace = <div className='place'>{entry.HAD[an].P}</div>;
                            }
                            if (entry.HAD[an].ME && entry.MM !== -1) {
                                english = <div className="english">{fractions(entry.HAD[an].ME)}</div>;
                            }

                            attempts.push(<td key={entry.BIB + "-AN" + an} className={tdClass}>{entry.HAD[an].M}{english}{wind}{anplace}</td>);
                        } else {
                            attempts.push(<td key={entry.BIB + "-AN-" + an}></td>);
                        }
                    } else {
                        attempts.push(<td key={entry.BIB + "-AN-" + an}></td>);
                    }
                } else {
                    attempts.push(<td key={entry.BIB + "-AN-" + an}></td>);
                }
            }

            if (entry.W !== undefined && entry.W !== "") {
                var windClass = entry.W > 2 ? "wind aided" : "wind";
                windBest = <div className={windClass}>{entry.W.toFixed(1)}</div>;
            }


            var lphText = "";
            if (hasHeats) {
                lphText = entry.HSF + "-" + entry.LP;
            } else {
                lphText = entry.LP;
            }
            if (entry.PF) {
                lphText += "|" + entry.PF;
            }

            var lph = <td className="center">{lphText}</td>;


            var multiPoints = null;
            if (entry.hasOwnProperty('MP')) {
                multiPoints = <span className="multipoints">{entry.MP} <small>{entry.MPST} ({entry.MPSTP})</small></span>
            }
            return (
                <tr key={entry.BIB} className={current}>
                    <td className="bold">{place}</td>
                    <td style={{ width: '1px', whiteSpace: 'nowrap' }}><button className='btnAthleteID' onClick={() => window.showAthlete(entry.ID, true, false)}>ID<br />w/Mark</button> <button className='btnAthleteID' onClick={() => window.showAthlete(entry.ID, false, false, 0,0, false)}>ID<br />Simple</button>
                        <button className='btnAthleteID' onClick={() => window.showAthlete(entry.ID, false, false, -1)}>ID<br />w/PBSB</button>
                        <button className='btnAthleteID' onClick={() => window.showAthlete(entry.ID, false, false, 1)}>ID<br />w/Highlight</button>
                        <button className='btnAthleteID' onClick={() => window.showLine2(entry.ID)}>Start<br />Line 2</button></td>

                    <td className="athlete bold" onClick={() => athleteClick(entry.AID, "h", entry.HAD, entry.ID)}>{flag}<span>{entry.A.N}{kc}</span>{aff}</td>
                    <td className="mark center bold">{entry.M} {multiPoints}{entry.Q}{entry.DQR}<div className="english">{fractions(entry.ME)}{windBest}</div>{tsPoints}</td>
                    {attempts}
                    {lph}
                </tr>
            );
        };

        return <table className={tableClass}>
            <thead>
                <tr><th>Place</th><th></th><th>Athlete</th><th className='center'>Result</th><th className='hAttempt'>1st</th><th className='hAttempt'>2nd</th><th className='hAttempt'>3rd</th><th className='hAttempt'>4th</th><th className='hAttempt'>5th</th><th className='hAttempt'>6th</th>
                    <th className="center hand" onClick={() => this.posSort()}>Pos</th></tr>
            </thead>
            <tbody>{entryArray.map(createEntry)}</tbody>
        </table>;
    }
}

class VFieldResults extends React.Component {
    constructor(props) {
        super(props); this.state = { posSort: false };
        this.state = { posSort: false };
        this.posSort = this.posSort.bind(this);
    }
    posSort() {
        this.setState({ posSort: !this.state.posSort });
    }
    render() {

        var meta = this.props.meta;
        var athleteClick = this.props.athleteClick;

        var entries = this.props.currentEvent.ED;
        var currentAthlete = this.props.currentEvent.CC;
        var currentAthlete2 = this.props.currentEvent.CC2;
        var bubble = this.props.currentEvent.BC;
        var hasHeats = this.props.currentEvent.HH;
        var heights = this.props.currentEvent.H.split(",");
        var heightsEng = this.props.currentEvent.HE.split(",");

        var fractions = function (m) {
            if (m)
                return m.replace("&#188;", "\u00BC").replace("&#189;", "\u00BD").replace("&#190;", "\u00BE");

            else
                return null;
        };
        var entryArray = [];
        for (var e in entries) {
            entryArray.push(entries[e]);
        }

        if (this.state.posSort) {
            entryArray.sort(sortPos);
        } else {
            entryArray.sort(sortPlaces);
        }

        for (var i = heights.length - 1; i--;) {
            if (heights[i] === "" || isNaN(heights[i])) heights.splice(i, 1);
            heightsEng[i] = fractions(heightsEng[i]);
        }
        var heightsTH = [];
        var useEnglish = this.props.currentEvent.hasOwnProperty("UE") ? this.props.currentEvent.UE : false;
        heights.map(function (height, i) {
            if (useEnglish) {
                heightsTH.push(<th key={"vrth" + i} className='vAttempt'>{heightsEng[i]}</th>);
            } else {
                heightsTH.push(<th key={"vrth" + i} className='vAttempt'>{height}<br />{heightsEng[i]}</th>);
            }
        });

        var tableClass = "raceResults";

        var createEntry = function (entry, index) {
            var place = null, flag = null, aff = null;

            var kc = null;
            if (entry.hasOwnProperty("KC")) {
                kc = <span className="kc">{entry.KC}</span>;
            }

            var tsPoints = null
            if (entry.hasOwnProperty("PT")) {
                tsPoints = entry.PT == 1 ? <div className="small tsPoints">{entry.PT} Pt</div> : <div className="small tsPoints">{entry.PT} Pts</div>;
            }
            if (meta.showFlag) {
                flag = entry.A.CC ? <div className="aff"><img src={'/img/flags/' + entry.A.CC + '.png'} />{entry.A.CC}</div> : null;

            }
            if (meta.showAff) {
                if (entry.TN) {
                    if (meta.showLogo) {
                        flag = entry.TC ? <div className="aff"><img src={'/img/logos/' + entry.TC + '.png'} /></div> : null;

                    }
                    var year = entry.Y ? "[" + entry.Y + "]" : null;
                    aff = entry.TN ? <div className="affiliation">{entry.TN} {year}</div> : null;
                } else {
                    if (meta.showLogo) {
                        flag = entry.A.TC ? <div className="aff"><img src={'/img/logos/' + entry.A.TC + '.png'} /></div> : null;

                    }
                    aff = entry.A.A ? <div className="affiliation">{entry.A.A}</div> : null;
                }
            }
            var current = "";
            if (entry.ID === currentAthlete || entry.ID == currentAthlete2) {
                current = "current";
            }

            if (entry.ID === bubble) {
                current += " bubble";
            }

            if (entry.DNS || entry.P === 999) place = "DNS";
            else if (entry.DNF || entry.P === 997) place = "DNF";
            else if (entry.DQ || entry.P === 996) place = "DQ";
            else if (entry.P === 998) place = "NH";
            else if (entry.P) place = entry.P;



            var lphText = "";
            if (hasHeats) {
                lphText = entry.HSF + "-" + entry.LP;
            } else {
                lphText = entry.LP;
            }
            if (entry.PF) {
                lphText += "|" + entry.PF;
            }

            var lph = <td className="center">{lphText}</td>;


            var multiPoints = null;
            if (entry.hasOwnProperty('MP')) {
                multiPoints = <span className="multipoints">{entry.MP} <small>{entry.MPST} ({entry.MPSTP})</small></span>
            }

            return (
                <tr key={entry.BIB} className={current}>
                    <td className="bold">{place}</td>
                    <td style={{ width: '1px', whiteSpace: 'nowrap' }}><button className='btnAthleteID' onClick={() => window.showAthlete(entry.ID, true, false)}>ID<br />w/Mark</button> <button className='btnAthleteID' onClick={() => window.showAthlete(entry.ID, false, false, 0,0, false)}>ID<br />Simple</button>
                        <button className='btnAthleteID' onClick={() => window.showAthlete(entry.ID, false, false, -1)}>ID<br />w/PBSB</button>
                        <button className='btnAthleteID' onClick={() => window.showAthlete(entry.ID, false, false, 1)}>ID<br />w/Highlight</button>
                        <button className='btnAthleteID' onClick={() => window.showLine2(entry.ID)}>Start<br />Line 2</button></td>


                    <td className="athlete bold" onClick={() => athleteClick(entry.AID, "v", entry.VAD, entry.ID)}>{flag}<span>{entry.A.N}{kc}</span>{aff}</td>
                    <td className="mark center bold">{entry.M} {multiPoints}{entry.Q}{entry.DQR}<div className="english">{fractions(entry.ME)}</div>{tsPoints}</td>
                    {heights.map(function (height, i) {
                        var heightStr = height.replace(".", "-");
                        if (entry.VAD) {
                            if (entry.VAD[heightStr]) {
                                if (entry.VAD[heightStr].A) {
                                    return <td key={entry.BIB + "-" + height} className="vAttempt">{entry.VAD[heightStr].A}</td>;
                                } else {
                                    return <td key={entry.BIB + "-" + height} className="vAttempt"></td>;
                                }
                            } else {
                                return <td key={entry.BIB + "-" + height} className="vAttempt"></td>;
                            }
                        } else {
                            return <td key={entry.BIB + "-" + height} className="vAttempt"></td>;
                        }
                    })}
                    {lph}
                </tr>
            );
        };

        return <table className={tableClass}>
            <thead>
                <tr><th>Place</th><th></th><th>Athlete</th><th className='center'>Result</th>{heightsTH}<th className="center hand" onClick={() => this.posSort()}>Pos</th></tr>
            </thead>
            <tbody>{entryArray.map(createEntry)}</tbody>
        </table>;
    }
}

class HeatResultTable extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        var meta = this.props.meta;
        var entryArray = this.props.entryArray;
        var hasWind = this.props.hasWind;
        var eventType = this.props.eventType;
        var heatWord = eventType === "RUN" || eventType === "STRAIGHT" || eventType === "RELAY" ? "Heat" : "Flight";
        var heatHead = null;
        if (this.props.hsf === 0) {
            heatHead = <tr className="heatName"><th colSpan="5">Pending {heatWord} Assignment</th></tr>;
        } else {
            heatHead = <tr className="heatName"><th colSpan="5">{heatWord} {this.props.hsf}</th></tr>;
        }

        var windRow = null;
        if (entryArray[0].W !== undefined && entryArray[0].W !== "" && hasWind) {
            var windRowClass = entryArray[0].W > 2 ? "resultWind aided" : "resultWind";
            windRow = <tr><th colSpan="4" className={windRowClass}>Wind: {entryArray[0].W.toFixed(1)} m/s</th></tr>;
        }

        return <table className="raceResults">
            <thead>
                {heatHead}
                {windRow}
                <tr><th>Pl</th><th></th><th>Athlete</th><th className='right'>Mark</th><th className='center'>Ln/Pos</th></tr>
            </thead>
            <tbody>{entryArray.map(function (e) { return <HeatResultRow key={"hr-" + e.HSF + "-" + e.BIB} entry={e} showFlag={meta.showFlag} showLogo={meta.showLogo} showAff={meta.showAff} /> })}</tbody>
        </table>;
    }
}

class HeatResultRow extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        var entry = this.props.entry;
        var flag = null, aff = null;

        if (this.props.showFlag) {
            flag = entry.A.CC ? <div className="aff"><img src={'/img/flags/' + entry.A.CC + '.png'} />{entry.A.CC}</div> : null;

        }
        if (this.props.showAff) {
            if (entry.TN) {
                if (this.props.showLogo) {
                    flag = entry.TC ? <div className="aff"><img src={'/img/logos/' + entry.TC + '.png'} /></div> : null;

                }
                var year = entry.Y ? "[" + entry.Y + "]" : null;
                aff = entry.TN ? <div className="affiliation">{entry.TN} {year}</div> : null;
            } else {
                if (this.props.showLogo) {
                    flag = entry.A.TC ? <div className="aff"><img src={'/img/logos/' + entry.A.TC + '.png'} /></div> : null;

                }
                aff = entry.A.A ? <div className="affiliation">{entry.A.A}</div> : null;
            }
        }

        var place;
        if (entry.DNS) place = "DNS";
        else if (entry.DNF) place = "DNF";
        else if (entry.DQ) place = "DQ";
        else if (entry.HP) place = entry.HP;

        var dqr = null;
        if (entry.hasOwnProperty("DQR")) {
            if (entry.DQR == "FS") place = "FS";
            else dqr = <small>[{entry.DQR}]</small>
        }

        if (entry.P) {
            place += " (" + entry.P + ")";
        }

        return (
            <tr>
                <td>{place}</td>
                <td style={{ width: '1px', whiteSpace: 'nowrap' }}><button className='btnAthleteID' onClick={() => window.showAthlete(entry.ID, true, false, 0, entry.HSF)}>ID<br />w/Mark</button> <button className='btnAthleteID' onClick={() => window.showAthlete(entry.ID, false, false, 0,0, false)}>ID<br />Simple</button> <button className='btnAthleteID' onClick={() => window.showAthlete(entry.ID, false, true)}>ID<br />w/Ln-Pos</button><button className='btnAthleteID' onClick={() => window.showLine2(entry.ID)}>Start<br />Line 2</button></td>

                <td className="athlete bold" onClick={() => athleteClick(entry.AID)}>{flag}<span>{entry.A.N}</span>{aff}</td>
                <td className="right bold">{entry.M} {entry.Q}{dqr}</td>
                <td className='center'>{entry.LP}</td>
            </tr>
        );

    }
}

class Records extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {

        if (!this.props.records) {
            return <div id="records">
                <h3>Records</h3>
                Records not available
                   </div>
        }

        var records = this.props.records.sort(function (a, b) {
            var aType = a.T;
            var bType = b.T;

            switch (a.T) {
                case "WR":
                    aType = 10;
                    break;
                case "AR":
                    aType = 20;
                    break;
                case "MR":
                    aType = 100;
                    break;
                case "HF":
                    aType = 110;
                    break;
                case "WL":
                    aType = 200;
                    break;
                case "AL":
                    aType = 210;
                    break;
                case "OS":
                    aType = 1000;
                    break;
                default:
                    aType = 500;
            }

            switch (b.T) {
                case "WR":
                    bType = 10;
                    break;
                case "AR":
                    bType = 20;
                    break;
                case "MR":
                    bType = 100;
                    break;
                case "HF":
                    bType = 110;
                    break;
                case "WL":
                    bType = 200;
                    break;
                case "AL":
                    bType = 210;
                    break;
                case "OS":
                    bType = 1000;
                    break;
                default:
                    bType = 500;
            }

            if (aType > bType)
                return 1;
            else if (aType < bType)
                return -1;
            else
                return 0;
        });

        var rRow = function (r) {
            r.D = r.D == 'Jan 01, 0001' ? '' : r.D.includes("Dec 31,") ? r.D.slice(-4) : r.D;
            return <tr><td className="type">{r.T}</td><td className="athlete"><span className="bold">{r.N}</span><br /><small>{r.A}</small></td><td className="bold">{r.M}</td><td>{r.D}<br /><small>{r.L}</small></td></tr>;
        };
        return <div id="records">
            <h3>Records</h3>
            <table id="resultRecords" cellSpacing="0">
                <thead>
                    <tr>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>{records.map(rRow)}</tbody>
            </table>
        </div>
    }
}

class HeatTrackResults extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {

        var meta = this.props.meta;
        var athleteClick = this.props.athleteClick;

        var entries = this.props.currentEvent.ED;
        var hasHeats = this.props.currentEvent.HH;
        var eventType = this.props.currentEvent.E.C;
        var currentHeat = this.props.currentEvent.CH;
        /*  not needed for heat results
        var bubble = this.props.currentEvent.BC;
        */
        var currentLap = this.props.currentEvent.CL;
        var splitList = this.props.currentEvent.SL;
        var hasReact = this.props.currentEvent.HR;
        var hasWind = this.props.currentEvent.HW;
        var status = this.props.currentEvent.S;

        var entryArray = [];
        var flip = false;

        for (var e in entries) {
            if (entries[e].HSF == currentHeat)
                entryArray.push(entries[e]);
        }

        entryArray.sort(sortPlaces);

        var tableClass = "raceResults";

        var windRow = null;
        var reactTH = hasReact ? <th className="center">React</th> : null;
        var heatTH = hasHeats ? <th className="center">Heat</th> : null;
        var windTH = hasHeats && hasWind ? <th className="center">Wind</th> : null;
        var splits = [];
        var splitReverse = false;
        if (splitList) {
            splits = splitList.split(",");
            if (splits.length > 4) {
                tableClass += "";
            }
            var cl = currentLap;
            entryArray.sort(function (a, b) {

                var aPlace;
                var bPlace;
                if (a.P)
                    aPlace = a.P;
                else if (a.SPD)
                    aPlace = a.SPD[cl] ? 250+a.SPD[cl].P : undefined;
                else
                    if (a.sortPlace)
                        aPlace = a.sortPlace;
                    //aPlace = a.HSF * 1000 + a.LP;
                    else
                        aPlace = 999999;

                if (b.P)
                    bPlace = b.P;
                else if (b.SPD)
                    bPlace = b.SPD[cl] ? 250+b.SPD[cl].P : undefined;
                else
                    if (b.sortPlace)
                        bPlace = b.sortPlace;
                    //bPlace = b.HSF * 1000 + b.LP;
                    else
                        bPlace = 999999;

                if (cl > 1) {
                    if ((!aPlace || aPlace === 9999) && a.SPD[cl - 1]) aPlace = a.SPD[cl - 1].P + 500; else if ((!aPlace || aPlace === 9999) && a.sortPlace) aPlace = a.sortPlace;
                    if ((!bPlace || bPlace === 9999) && b.SPD[cl - 1]) bPlace = b.SPD[cl - 1].P + 500; else if ((!bPlace || bPlace === 9999) && b.sortPlace) bPlace = b.sortPlace;
                }

                if (!aPlace)
                    return 1;
                if (!bPlace)
                    return -1;
                if (aPlace < bPlace)
                    return -1;
                if (aPlace > bPlace)
                    return 1;
                return 0;
            });

            splits.splice(currentLap, splits.length - currentLap);
            if (status == "Live" || status == "Reviewing") {
                splits.reverse();
                splitReverse = true;
            }
        }

        if (entryArray[0].W !== undefined && entryArray[0].W !== "" && !hasHeats && hasWind) {
            var windRowClass = entryArray[0].W > 2 ? "resultWind aided" : "resultWind";
            windRow = <tr><th colSpan="4" className={windRowClass}>Wind: {entryArray[0].W.toFixed(1)} m/s</th></tr>;
        }

        var createEntry = function (entry, index) {
            var reactTD = null;
            var heatTD = null;
            var windTD = null;
            var tiebreak = null;

            if (hasReact) {
                if (entry.RT)
                    reactTD = <td className="center">{entry.RT.toFixed(3)}</td>;
                else
                    reactTD = <td className="center"></td>;
            }

            if (hasHeats) {
                heatTD = <td className="center">{entry.HSF}</td>;
                if (hasWind) {
                    if (entry.W !== undefined && entry.W !== "") {
                        var windTDClass = entry.W > 2 ? "center aided" : "center";
                        windTD = <td className={windTDClass}>{entry.W.toFixed(1)} m/s</td>;
                    } else {
                        windTD = <td></td>;
                    }
                }
            }

            if (entry.MTB) {
                tiebreak = <div className="small">{entry.MTB}</div>;
            }



            var place = null, flag = null, aff = null;

            if (meta.showFlag) {
                flag = entry.A.CC ? <div className="aff"><img src={'/img/flags/' + entry.A.CC + '.png'} />{entry.A.CC}</div> : null;

            }
            if (meta.showAff) {
                if (entry.TN) {
                    if (meta.showLogo) {
                        flag = entry.TC ? <div className="aff"><img src={'/img/logos/' + entry.TC + '.png'} /></div> : null;

                    }
                    var year = entry.Y ? "[" + entry.Y + "]" : null;
                    aff = entry.TN ? <div className="affiliation">{entry.TN} {year}</div> : null;
                } else {
                    if (meta.showLogo) {
                        flag = entry.A.TC ? <div className="aff"><img src={'/img/logos/' + entry.A.TC + '.png'} /></div> : null;

                    }
                    aff = entry.A.A ? <div className="affiliation">{entry.A.A}</div> : null;
                }
            }

            if (entry.RRD) {
                var year = entry.Y ? "[" + entry.Y + "]" : null;
                aff = <div className="affiliation">{year} {entry.RRD.filter(function (rr) { return rr.L > 0 && rr.L <= 4 }).map(function (rr) { return rr.A ? rr.A.N ? rr.A.N : "" : "" }).join(", ")}</div>;
            }

            if (entry.DNS || entry.P === 999) place = "DNS";
            else if (entry.DNF || entry.P === 997) place = "DNF";
            else if (entry.DQ || entry.P === 996) place = "DQ";
            else if (entry.P === 998) place = "FS";
            else if (entry.P) place = entry.P;

            var dqr = null;
            if (entry.hasOwnProperty("DQR")) {
                if (entry.DQR == "FS") place = "FS";
                else dqr = <small>[{entry.DQR}]</small>
            }

            var multiPoints = null;
            if (entry.hasOwnProperty('MP')) {
                multiPoints = <span className="multipoints">{entry.MP} <small>{entry.MPST} ({entry.MPSTP})</small></span>
            }

            return (
                <tr key={entry.BIB}>
                    <td className="bold">{place}</td>
                    <td style={{ width: '1px', whiteSpace: 'nowrap' }}><button className='btnAthleteID' onClick={() => window.showAthlete(entry.ID, true, false,0,entry.HSF)}>ID<br />w/Mark</button> <button className='btnAthleteID' onClick={() => window.showAthlete(entry.ID, false, false,0,0,false)}>ID<br />Simple</button> <button className='btnAthleteID' onClick={() => window.showAthlete(entry.ID, false, true)}>ID<br />w/Ln-Pos</button><button className='btnAthleteID' onClick={() => window.showLine2(entry.ID)}>Start<br />Line 2</button>

                    </td>


                    <td className="athlete bold" onClick={() => athleteClick(entry.AID)}>{flag}<span>{entry.A.N}</span>{aff}</td>
                    <td className="right bold">{entry.M} {multiPoints}{entry.Q} {tiebreak}{dqr}</td>
                    {reactTD}
                    {splits.map(function (split, i) {
                        var ls = "-", mv = null;
                        var iPos = splitReverse ? splits.length - i : i + 1;
                        if (entry.SPD) {
                            if (entry.SPD[iPos]) {
                                if (entry.SPD[iPos].P !== 9999) {
                                    if (iPos > 1) {
                                        ls = entry.SPD[iPos].LS;
                                        //ls = entry.SPD[iPos].LS.includes("|") ? null : entry.SPD[iPos].LS;
                                        if (entry.SPD[iPos].M > 0)
                                            mv = <span className="up">{entry.SPD[iPos].M}</span>;
                                        else if (entry.SPD[iPos].M < 0)
                                            mv = <span className="down">{entry.SPD[iPos].M}</span>;
                                        else if (entry.SPD[iPos].M === 0)
                                            mv = <span className="same"></span>;
                                    }
                                    return <td key={entry.BIB + "-S" + (iPos)} className="center split">
                                        <div>{entry.SPD[iPos].CS}</div>
                                        <div className="small">{ls}</div>
                                        <div className="small">Pl: {entry.SPD[iPos].P} {mv}</div>
                                    </td>;
                                } else {
                                    return <td key={entry.BIB + "-S" + (iPos)} className="center split"></td>;
                                }
                            } else {
                                return <td key={entry.BIB + "-S" + (iPos)} className="center split"></td>;
                            }
                        } else {
                            return <td key={entry.BIB + "-S" + (iPos)} className="center split"></td>;
                        }
                    })}
                    {windTD}
                    {heatTD}
                    <td className="center">{entry.LP}</td>
                </tr>
            );
        };



        return <div className="currentHeat"><h3>Current Heat</h3><table className={tableClass}>
            <thead>
                {windRow}
                <tr><th>Place</th><th></th><th>Athlete</th><th className='right'>Result</th>{reactTH}{splits.map(function (split) { return <th key={split + "m"} className="center">{split}</th>; })}{windTH}{heatTH}<th className="center">Ln/Pos</th></tr>
            </thead>
            <tbody>{entryArray.map(createEntry)}</tbody>
        </table>

        </div>

    }
}

class MultiResults extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        var meta = this.props.meta;
        var currentEvent = this.props.currentEvent;
        var entries = currentEvent.ED;
        var eventType = this.props.eventType;
        var athleteClick = this.props.athleteClick;

        var entryArray = [];

        for (var e in entries) {
            entryArray.push(entries[e]);
        }

        entryArray.sort(sortPlaces);

        var tableClass = "raceResults multiTable";

        var header = null;
        var colCount;

        switch (eventType) {
            case "Decathlon":
                colCount = 10;
                break;
            case "Heptathlon":
                colCount = 7;
                break;
            case "Indoor Heptathlon":
                colCount = 7;
                break;
            case "Indoor Pentathlon":
                colCount = 5;
                break;
        }
        if (eventType == "Decathlon") {
            header = <tr><th>Place</th><th></th><th>Athlete</th><th className='center'>Total</th><th className="center">100m</th><th className="center">LJ</th><th className="center">SP</th><th className="center">HJ</th><th className="center">400m</th><th className="center">110mH</th><th className="center">DT</th><th className="center">PV</th><th className="center">JT</th><th className="center">1500m</th></tr>;
        }

        if (eventType == "Heptathlon") {
            header = <tr><th>Place</th><th></th><th>Athlete</th><th className='center'>Total</th><th className="center">100mH</th><th className="center">HJ</th><th className="center">SP</th><th className="center">200m</th><th className="center">LJ</th><th className="center">JT</th><th className="center">800m</th></tr>;
        }

        if (eventType == "Indoor Heptathlon") {
            header = <tr><th>Place</th><th></th><th>Athlete</th><th className='center'>Total</th><th className="center">60m</th><th className="center">LJ</th><th className="center">SP</th><th className="center">HJ</th><th className="center">60mH</th><th className="center">PV</th><th className="center">1000m</th></tr>;
        }

        if (eventType == "Indoor Pentathlon") {
            header = <tr><th>Place</th><th></th><th>Athlete</th><th className='center'>Total</th><th className="center">60mH</th><th className="center">HJ</th><th className="center">SP</th><th className="center">LJ</th><th className="center">800m</th></tr>;
        }



        var createEntry = function (entry, index) {


            var place = null, flag = null, aff = null;

            var tsPoints = null;
            if (entry.hasOwnProperty("PT")) {
                tsPoints = entry.PT == 1 ? <div className="small tsPoints">{entry.PT} Pt</div> : <div className="small tsPoints">{entry.PT} Pts</div>;
            }


            if (meta.showFlag) {
                flag = entry.A.CC ? <div className="aff"><img src={'/img/flags/' + entry.A.CC + '.png'} />{entry.A.CC}</div> : null;

            }
            if (meta.showAff) {
                if (entry.TN) {
                    if (meta.showLogo) {
                        flag = entry.TC ? <div className="aff"><img src={'/img/logos/' + entry.TC + '.png'} /></div> : null;

                    }
                    var year = entry.Y ? "[" + entry.Y + "]" : null;
                    aff = entry.TN ? <div className="affiliation">{entry.TN} {year}</div> : null;
                } else {
                    if (meta.showLogo) {
                        flag = entry.A.TC ? <div className="aff"><img src={'/img/logos/' + entry.A.TC + '.png'} /></div> : null;

                    }
                    aff = entry.A.A ? <div className="affiliation">{entry.A.A}</div> : null;
                }
            }
            if (entry.DNS || entry.P === 999) {
                place = "DNS";
            }
            else if (entry.DNF || entry.P === 997) {
                place = "DNF";
                entry.MM = null;
            }
            else if (entry.DQ || entry.P === 996) {
                place = "DQ";
                entry.MM = null;
            }
            else if (entry.P === 998) {
                place = "FS";
            }
            else if (entry.P) place = entry.P;

            var pointsCols = [];
            if (entry.M) {
                var pointArray = entry.M.split(",");
                var len = pointArray.length;
                for (var x = 0; x < colCount; x++) {
                    if (x >= len)
                        pointsCols.push(<td></td>);
                    else if (pointArray[x] == "")
                        pointsCols.push(<td></td>);
                    else {
                        var pointDetail = pointArray[x].split("|");
                        pointsCols.push(<td className="center points"><div>{pointDetail[0]}</div>{pointDetail[1]} ({pointDetail[4]})<br /><small>{pointDetail[2]} ({pointDetail[3]})</small></td>);
                    }
                }
            } else {
                for (var x = 0; x < colCount; x++) {
                    pointsCols.push(<td></td>);
                }
            }


            return (
                <tr key={entry.BIB}>
                    <td className="bold">{place}</td>
                    <td style={{ width: '1px', whiteSpace: 'nowrap' }}><button className='btnAthleteID' onClick={() => window.showAthlete(entry.ID, true, false)}>ID<br />w/Mark</button> <button className='btnAthleteID' onClick={() => window.showAthlete(entry.ID, false, false,0,0,false)}>ID<br />Simple</button>
                        <button className='btnAthleteID' onClick={() => window.showAthlete(entry.ID, false, false, -1)}>ID<br />w/PBSB</button>
                        <button className='btnAthleteID' onClick={() => window.showAthlete(entry.ID, false, false, 1)}>ID<br />w/Highlight</button>
                        <button className='btnAthleteID' onClick={() => window.showLine2(entry.ID)}>Start<br />Line 2</button></td>
                    <td className="athlete bold" onClick={() => athleteClick(entry.AID)}>{flag}<span>{entry.A.N}</span>{aff}</td>
                    <td className="center bold">{entry.MM}{entry.DQR}{tsPoints}</td>
                    {pointsCols}
                </tr>
            );
        };


        return <div className="resultsDiv">
            <table className={tableClass}>
                <thead>
                    {header}
                </thead>
                <tbody>{entryArray.map(createEntry)}</tbody>
            </table>
        </div>

    }
}

class EventGraphics extends React.Component {
    constructor(props) {
        super(props);
        this.getWeather = this.getWeather.bind(this);
        this.updateWeather = this.updateWeather.bind(this);
        this.showInterview = this.showInterview.bind(this);
        this.showGraphic = this.showGraphic.bind(this);
        this.show2LineWithLogo = this.show2LineWithLogo.bind(this);

    }
    showEventTitle(mid,goldlogo) {
        var data = "";

        data = '{"gu":' + window.globalGU + ',"mid":' + mid + ',"goldlogo":'+goldlogo+'}';

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/ShowEventTitle/' + mid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    showEventLocation(mid) {
        var data = "";

        data = '{"gu":' + window.globalGU + ',"mid":' + mid + '}';

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/ShowEventDetails/' + mid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    showNextEvent(mid) {
        var data = "";

        data = '{"gu":' + window.globalGU + ',"mid":' + mid + '}';

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/ShowNextEvent/' + mid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    show2LineWithLogo(line12ll, line22ll, logo2ll) {
        var gu = window.globalGU;

        var data = '{"gu":' + window.globalGU + ',"layer":"interview","name":"' + line12ll + '", "affiliation":"' + logo2ll + '","note":"' + line22ll + '", "logo":"' + logo2ll + '","logoFolder":"logos","position":"' + "center" + '"}';

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/ShowInterview/' + window.globalMID, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    getWeather(lat, long) {

        var weatherAPIUrl = "https://api.weatherstack.com/current";
        var weatherAPIKey = "?access_key=788dd7f6aad4bcf81a874bc77f1e808b";

        var coordinates = lat + "," + long;

        var weatherAPI = weatherAPIUrl + weatherAPIKey + "&units=f&query=" + coordinates + "&callback=?";
        var classThis = this;
        $.getJSON(weatherAPI, function (data) {
            var t = Number(data.current.temperature);
            var f = Number(data.current.feelslike);
            var fl = Math.round(f) + "&deg;F / " + Math.round((f - 32) * .5556) + "&deg;C";
            var temp = Math.round(t) + "&deg;F / " + Math.round((t - 32) * .5556) + "&deg;C";
            
            var w = Number(data.current.wind_speed);
            var wind = Math.round((w * 0.44704), 1).toFixed(1) + " m/s";

            var h = Number(data.current.humidity);
            var humidity = Math.round(h) + "%"; 0
            var time = moment.unix(data.location.localtime_epoch + 14400).tz(data.location.timezone_id).format('HH:mm z');
            classThis.temp.value = temp;
            classThis.wind.value = wind;
            classThis.humidity.value = humidity;
            classThis.conditions.value = data.current.weather_descriptions[0];
            classThis.time.value = time;
            classThis.icon.value = data.current.weather_descriptions[0].replace(" ","-");
            classThis.feelsLike.value = fl;
        });


   }
    updateWeather(mid) {
        var data = '{"gu":' + window.globalGU + ',"layer":"weather","temp":"' + this.temp.value + '","humidity":"' + this.humidity.value + '","wind":"' + this.wind.value + '","conditions":"' + this.conditions.value + '","feelsLike":"' + this.feelsLike.value + '","time":"' + this.time.value + '","icon":"' + this.icon.value + '"}';

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/ShowWeather/' + window.globalMID, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    showInterview(align = "left") {
        var gu = window.globalGU;

        align = document.getElementById("centerLT").value;

        var data = '{"gu":' + window.globalGU + ',"layer":"interview","name":"' + this.iName.value + '", "affiliation":"' + this.iAff.value + '","note":"' + this.iNote.value + '", "logo":"' + this.iAff.value + '","logoFolder":"flags","position":"' + align +'"}';

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/ShowInterview/' + window.globalMID, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    showCustom2Line(l1, l2, align="left") {
        var gu = window.globalGU;
        align = document.getElementById("centerLT").value;
        var data = '{"gu":' + window.globalGU + ',"layer":"interview","name":"' + l1 + '","note":"' + l2 + '","position":"'+align+'"}';

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/ShowInterview/' + window.globalMID, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    showCustom3Line(l1, l2, l3, align = "left") {
        var gu = window.globalGU;
        align = document.getElementById("centerLT").value;
        var data = '{"gu":' + window.globalGU + ',"layer":"interview","name":"' + l1 + '","note":"' + l2 + '", "affiliation":"' + l3 + '","position":"' + align + '"}';

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/ShowInterview/' + window.globalMID, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    showClockSponsor(sponsor, duration) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', '/api/SyncGraphics/SetClockSponsor/' + window.globalMID + '/' + sponsor + '/' + duration, true);
        xhr.send();
    }
    showClockNote(cn, note) {

        var data = "";
        var gu = window.globalGU;

        data = '{"gu":' + gu + ', "action":"SHOWNOTE", "note":"'+note+'","meid":' + cn + '}';
        
        var xhr = new XMLHttpRequest();
        xhr.open('PATCH', '/api/SyncGraphics/SetClock/' + cn, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    closeClockNote(cn) {

        var data = "";
        var gu = window.globalGU;

        data = '{"gu":' + gu + ', "action":"CLOSENOTE","meid":' + cn + '}';

        var xhr = new XMLHttpRequest();
        xhr.open('PATCH', '/api/SyncGraphics/SetClock/' + cn, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    showGraphic() {
        var gu = window.globalGU;

        var data = '{"gu":' + window.globalGU + ',"layer":"graphic","src":"' + this.graphicSRC.value + '"}';

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/ShowGraphic/' + window.globalMID, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    showGraphicPre(filename) {
        var gu = window.globalGU;

        var data = '{"gu":' + window.globalGU + ',"layer":"graphic","src":"' + filename + '"}';

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/ShowGraphic/' + window.globalMID, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }

    showCommentators(mid) {
        var data = "";

        data = '{"gu":' + window.globalGU + ',"mid":' + mid + '}';

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/ShowCommentators/' + mid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    showCommentatorsOnCamera(mid) {
        var data = "";

        data = '{"gu":' + window.globalGU + ',"mid":' + mid + '}';

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/ShowCommentatorsOnCamera/' + mid, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(data);
    }
    setBoxCount(event) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/SetBoxCount/' + window.globalGU + "/" + mid + "/" + event.target.value, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send();
    }
    setBoxEvent(box) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/SetBoxEvent/' + window.globalGU + "/" + mid + "/" + box + "/" + document.getElementById("box" + box).value, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send();
    }
    setBoxCC(box, cc) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/SetBoxCC/' + window.globalGU + "/" + mid + "/" + box + "/" + cc, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send();

    }
    setBoxCC2(box, cc) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/SetBoxCC2/' + window.globalGU + "/" + mid + "/" + box + "/" + cc, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send();

    }
    setBoxResults(box,res) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/SetBoxResult/' + window.globalGU + "/" + mid + "/" + box + "/" + res, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send();
    }
    setBoxCCShow(box, show) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/SetBoxCCShow/' + window.globalGU + "/" + mid + "/" + box + "/" + show, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send();
    }

    setFieldBarEvent(box) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/SetFieldBarEvent/' + window.globalGU + "/" + mid + "/" + box + "/" + document.getElementById("fb" + box).value, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send();
    }
    setFieldBarCC(box, cc) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/SetFieldBarCC/' + window.globalGU + "/" + mid + "/" + box + "/" + cc, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send();

    }
    setFieldBarCC2(box, cc) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/SetFieldBarCC2/' + window.globalGU + "/" + mid + "/" + box + "/" + cc, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send();

    }
    setFieldBarResults(box, res) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/SetFieldBarResult/' + window.globalGU + "/" + mid + "/" + box + "/" + res, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send();
    }
    setFieldBarBoth(box, both) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/SetFieldBarBoth/' + window.globalGU + "/" + mid + "/" + box + "/" + both, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send();
    }
    setFieldBarShow(box, show) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/SetFieldBarShow/' + window.globalGU + "/" + mid + "/" + box + "/" + show, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send();
    }
    setFieldBarEnglish(box, english) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/SyncGraphics/SetFieldBarEnglish/' + window.globalGU + "/" + mid + "/" + box + "/" + english, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send();
    }

    render() {
        var mid = this.props.mid;
        var meta = this.props.meta;
        var subHeadStyle = { width: '300px' };
        return <div style={{ margin: '15px' }}>
            <div id="title">
                <button onClick={() => this.showEventTitle(mid, false)} className="btn btn-secondary">Show Non-ESPN Meet Title</button>
                <br />
                <button onClick={() => this.showGraphicPre(mid + "-0.png")} className="btn btn-secondary">Show ESPN Meet Title</button>
                {/* 
                <button onClick={() => this.showEventTitle(mid, false)} className="btn btn-secondary">Show Meet Title</button>
                <button onClick={() => this.showEventTitle(mid, true)} className="btn btn-secondary">Show Meet Title w/Gold</button>
                <button onClick={() => this.showEventLocation(mid)} className="btn btn-secondary">Show Meet Location</button>
                <button onClick={() => this.showNextEvent(mid)} className="btn btn-secondary">Show Next Meet</button>
                */}
            </div>
            <br />
            <div id="commentators">
                <button onClick={() => this.showCommentators(mid)} className="btn btn-secondary">Show Commentators</button>   <button onClick={() => this.showCommentatorsOnCamera(mid)} className="btn btn-secondary">Show On-Camera Commentators (B10)</button>
            </div>
            <br />
            <div id="weather">
                <button onClick={() => this.updateWeather(mid)} className="btn btn-secondary">Show Weather</button>
                <button onClick={() => this.getWeather(meta.lat, meta.long)} className="btn btn-secondary">Get Latest Weather</button>
                <input type="text" ref={input => this.temp = input} placeholder="Temp" />
                <input type="text" ref={input => this.humidity = input} placeholder="Humdity" />
                <input type="text" ref={input => this.wind = input} id="wind" placeholder="Wind" />
                <input type="text" ref={input => this.conditions = input} placeholder="Conditions" />
                <input type="text" ref={input => this.time = input} placeholder="Time" />
                <input type="text" ref={input => this.icon = input} placeholder="Icon" />
                <input type="text" ref={input => this.feelsLike = input} placeholder="Feels Like" />&nbsp;&nbsp;
            </div>
            <br />
            <div id="interview">
                <button onClick={() => this.showInterview()} className="btn btn-secondary">Show Interview</button>
                <input type="text" ref={input => this.iName = input} placeholder="Name" />
                <input type="text" ref={input => this.iNote = input} placeholder="Title/Note" />
                <input type="text" ref={input => this.iAff = input} placeholder="AFF" />
            </div>
            <br />
            <br />
            <div id="feeds">

               

                {/*

                 <button onClick={() => this.showCustom2Line("Chris Miller", "Divisional Vice President Global Brand Strategy &amp; Innovation, Abbott")} className="btn btn-secondary">Chris Miller: Divisional Vice President Global Brand Strategy & Innovation, Abbott</button>
                <br />
                <br />
                <button onClick={() => this.showCustom2Line("Morgan Beadlescomb", "2023 USATF 5K & Abbott Dash to the Finish Line 5K Champion")} className="btn btn-secondary">Morgan Beadlescomb</button>
                <button onClick={() => this.showCustom2Line("Annie Rodenfels", "2023 USATF 5K & Abbott Dash to the Finish Line 5K Champion")} className="btn btn-secondary">Annie Rodenfels</button>
                <br />
                <br />
                <button onClick={() => this.show2LineWithLogo("Follow USA Track & Field", "On Social Media @USATF", "usatf-wings")} className="btn btn-secondary">Follow USATF</button>&nbsp;&nbsp;
                <button onClick={() => this.show2LineWithLogo("Join or Renew Today", "usatf.org/membership", "usatf-wings")} className="btn btn-secondary">Join USATF</button>&nbsp;&nbsp;
                <button onClick={() => this.show2LineWithLogo("Support Team USATF", "Shop Today at usatf.org/store", "usatf-wings")} className="btn btn-secondary">Shop Today</button>&nbsp;&nbsp;
                <br />
                <br />
                <button onClick={() => this.showGraphicPre(mid + "-9.png")} className="btn btn-secondary">Start Times</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-3.png")} className="btn btn-secondary">RC Points</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-6.png")} className="btn btn-secondary">RC Prize Money</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-10.png")} className="btn btn-secondary">RC Men's Standings</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-11.png")} className="btn btn-secondary">RC Women's Standings</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-4.png")} className="btn btn-secondary">5K Prize</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-8.png")} className="btn btn-secondary">Men's Record</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-7.png")} className="btn btn-secondary">Women's Record</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-5.png")} className="btn btn-secondary">Past Winners</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("New York, NY", "")} className="btn btn-secondary">New York, NY</button>&nbsp;&nbsp;


                <button onClick={() => this.showCustom2Line("Next Meet: Meeting Hauts-de-France Pas-de-Calais", "Wednesday, 15 February 2023")} className="btn btn-secondary">Next Meet: Meeting Hauts-de-France Pas-de-Calais</button>

                <button onClick={() => this.showGraphicPre(mid + "-10.png")} className="btn btn-secondary">Meet Schedule</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-7.png")} className="btn btn-secondary">International Money</button>&nbsp;&nbsp;

                 <button onClick={() => this.showCustom2Line("Bermuda","")} className="btn btn-secondary">Bermuda</button>&nbsp;&nbsp;


 <button onClick={() => this.showCustom2Line("New York, NY", "")} className="btn btn-secondary">New York, NY</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("ATHING MU", "Women's 800m")} className="btn btn-secondary">Athing Mu</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("NOAH LYLES", "Men's 200m")} className="btn btn-secondary">Noah Lyles</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("SYDNEY MCLAUGHLIN-LEVRONE", "Women's 400m")} className="btn btn-secondary">Sydney M-L</button>&nbsp;&nbsp;

 <button onClick={() => this.showCustom2Line("Next Stop: Ostrava Golden Spike", "Tuesday, 27 June")} className="btn btn-secondary">Next Stop</button>&nbsp;&nbsp;

<button onClick={() => this.showCustom2Line("Footage Courtesy", "Dartmouth, Delaware State, Harvard, Howard")} className="btn btn-secondary">Footage Courtesy</button>
                <button onClick={() => this.showCustom2Line("© 2024 ESPN, Inc. All Rights Reserved", "")} className="btn btn-secondary">© 2024 ESPN</button>

<button onClick={() => this.showGraphicPre(mid + "-4.png")} className="btn btn-secondary">RC Money</button>&nbsp;&nbsp;




                <button onClick={() => this.showCustom2Line("Nike Track & Field Center at the Armory", "New York, USA")} className="btn btn-secondary">Armory, NY</button>&nbsp;&nbsp;


                <button onClick={() => this.showCustom2Line("YAROSLAVA MAHUCHIKH (UKR)", "Women's High Jump")} className="btn btn-secondary">YAROSLAVA MAHUCHIKH</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("LAURA MUIR (GBR)", "Women's 2 Mile")} className="btn btn-secondary">LAURA MUIR</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("JESSICA HULL (AUS)", "Women's Wanamaker Mile")} className="btn btn-secondary">JESSICA HULL</button>&nbsp;&nbsp;

                <button onClick={() => this.showCustom2Line("YARED NUGUSE (USA)", "Men's Wanamaker Mile")} className="btn btn-secondary">YARED NUGUSE</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("JOSH KERR (GBR)", "Men's 2 Mile")} className="btn btn-secondary">JOSH KERR</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("CHRISTIAN COLEMAN (USA)", "Men's 60m")} className="btn btn-secondary">CHRISTIAN COLEMAN</button>&nbsp;&nbsp;

                <button onClick={() => this.showCustom2Line("Next Stop: World Indoor Tour Madrid", "24 February - Madrid (ESP)")} className="btn btn-secondary">Next Stop</button>&nbsp;&nbsp;


                <br /><br />


                <button onClick={() => this.showGraphicPre("blank.png")} className="btn btn-secondary">Blank</button>&nbsp;&nbsp;

                <button onClick={() => this.showGraphicPre(mid + "-1.png")} className="btn btn-secondary">Timetable</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-3.png")} className="btn btn-secondary">Earlier Today</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-4.png")} className="btn btn-secondary">Yesterday _ FRANCE</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-5.png")} className="btn btn-secondary">6 Feb - Torun (POL)</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-6.png")} className="btn btn-secondary">4 Feb - Boston (USA)</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-2.png")} className="btn btn-secondary">Tour Schedule</button>&nbsp;&nbsp;

                VT - ATHLETE BROLL - NUGUSE, COLEMAN, KERR, HULL, MUIR, AND MAHUCHIKH

                  <button onClick={() => this.showCustom2Line("Miramar, FL", "")} className="btn btn-secondary">Miramar, FL</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("Ansin Sports Complex", "")} className="btn btn-secondary">Ansin Sports Complex</button>&nbsp;&nbsp;

                <button onClick={() => this.showCustom2Line("Next Stop: Penn Relays & Drake Relays", "27 April - USA")} className="btn btn-secondary">Next Stop</button>&nbsp;&nbsp;

                 <button onClick={() => this.showGraphicPre(mid + "-2.png")} className="btn btn-secondary">Schedule</button>&nbsp;&nbsp;

                <button onClick={() => this.showCustom2Line("TOBI AMUSAN (NGR)", "Women's 100m Hurdles")} className="btn btn-secondary">Tobi AMUSAN</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("JAKE WIGHTMAN (GBR)", "Men's 1500m")} className="btn btn-secondary">Jake WIGHTMAN</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("ELAINE THOMPSON-HERAH (JAM)", "Women's 100m")} className="btn btn-secondary">Elaine THOMPSON-HERAH</button>&nbsp;&nbsp;

                <button onClick={() => this.showCustom2Line("FRED KERLEY (USA)", "Men's 100m")} className="btn btn-secondary">FRED KERLEY</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("NOAH LYLES (USA)", "Men's 200m")} className="btn btn-secondary">NOAH LYLES</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("SYDNEY MCLAUGHLIN-LEVRONE (USA)", "Women's 400m")} className="btn btn-secondary">SYDNEY MCLAUGHLIN-LEVRONE</button>&nbsp;&nbsp;


                <button onClick={() => this.showGraphicPre(mid + "-3.png")} className="btn btn-secondary">Yesterday</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-4.png")} className="btn btn-secondary">Earlier</button>&nbsp;&nbsp;
                <br />
                <br />
                <button onClick={() => this.showGraphicPre(mid + "-1.png")} className="btn btn-secondary">Upcoming Tour</button>&nbsp;&nbsp;

                 <button onClick={() => this.showGraphicPre(mid + "-1.png")} className="btn btn-secondary">Sabastian Sawe</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-2.png")} className="btn btn-secondary">Daniel Ebenyo</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-3.png")} className="btn btn-secondary">Mathew Kimeli</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-4.png")} className="btn btn-secondary">Elkanah Kibet</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-5.png")} className="btn btn-secondary">Jake Riley</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-6.png")} className="btn btn-secondary">Sam Chelanga</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-7.png")} className="btn btn-secondary">Emmaculate Anyango</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-8.png")} className="btn btn-secondary">Jesca Chelangat</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-9.png")} className="btn btn-secondary">Cintia Chepngeno</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-10.png")} className="btn btn-secondary">Stacey Ndiwa</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-11.png")} className="btn btn-secondary">Tristin Van Ord</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-12.png")} className="btn btn-secondary">Daniel Romanchuk</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-13.png")} className="btn btn-secondary">Aaron Pike</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-14.png")} className="btn btn-secondary">Josh Cassidy</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-15.png")} className="btn btn-secondary">Susannah Scaroni</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-16.png")} className="btn btn-secondary">Jenna Fesemyer</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-17.png")} className="btn btn-secondary">Yen Hoang</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-18.png")} className="btn btn-secondary">Jackson Hogsed</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-19.png")} className="btn btn-secondary">Zahara Bernal</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("Ansin Sports Complex", "Miramar, FL")} className="btn btn-secondary">Ansin Sports Complex</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("© 2024 U.S. Olympic & Paralympic Committee", "All Rights Reserved")} className="btn btn-secondary">© Copyright USOPC</button>&nbsp;&nbsp;

                <button onClick={() => this.showCustom2Line("Gordon Indoor Track", "Cambridge, Massachusetts")} className="btn btn-secondary">Gordon Indoor Track</button>&nbsp;&nbsp;

                <button onClick={() => this.showGraphicPre("7583-2.png")} className="btn btn-secondary">Commentators</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre("7583-3.png")} className="btn btn-secondary">Sideline</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre("7583-4.png")} className="btn btn-secondary">Field Schedule</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre("7583-5.png")} className="btn btn-secondary">Track Schedule</button>&nbsp;&nbsp;

                 <button onClick={() => this.showCustom2Line("Gordon Indoor Track", "Cambridge, Massachusetts")} className="btn btn-secondary">Gordon Indoor Track</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("", "Today's coverage is presented without commentary")} className="btn btn-secondary">No Commentator - Change Dropdown to LEFT</button>&nbsp;&nbsp;
                

                 <button onClick={() => this.showGraphicPre("blank.png")} className="btn btn-secondary">Blank</button>&nbsp;&nbsp;
                <br />
                <br />
                <button onClick={() => this.showCustom2Line("Gordon Indoor Track", "Cambridge, Massachusetts")} className="btn btn-secondary">Gordon Indoor Track</button>&nbsp;&nbsp;

                <button onClick={() => this.showGraphicPre(mid + "-3.png")} className="btn btn-secondary">Multi/Field Schedule</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-2.png")} className="btn btn-secondary">Track Schedule</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-4.png")} className="btn btn-secondary">Commentators: Korzeniowski and  Altsher</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-5.png")} className="btn btn-secondary">Commentators: Altsher and Korzeniowski</button>&nbsp;&nbsp;

                <button onClick={() => this.showCustom2Line("", "© 2025 ESPN, Inc. All Rights Reserved")} className="btn btn-secondary">© 2025 ESPN, Inc. All Rights Reserved</button>&nbsp;&nbsp;

                <br />
                <br />
                <br />
                <button onClick={() => this.showCustom2Line("Noah Lyles", "Men's 60m")} className="btn btn-secondary">Noah Lyles</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("Julien Alfred", "Women's 300m")} className="btn btn-secondary">Julien Alfred</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("Jake Wightman", "Men's 1500m")} className="btn btn-secondary">Jake Wightman</button>&nbsp;&nbsp;

                <button onClick={() => this.showCustom2Line("Jessica Hull", "Women's 3000m")} className="btn btn-secondary">Jessica Hull</button>&nbsp;&nbsp;

                <button onClick={() => this.showCustom2Line("the TRACK at new balance", "Boston, USA")} className="btn btn-secondary">the TRACK</button>&nbsp;&nbsp;

               

                <button onClick={() => this.showGraphicPre(mid + "-1.png")} className="btn btn-secondary">Timetable</button>&nbsp;&nbsp;
                <br />
                <br />
                <br />

                <button onClick={() => this.showGraphicPre(mid + "-3.png")} className="btn btn-secondary">Still to Come (3000m on)</button>&nbsp;&nbsp;

                <button onClick={() => this.showGraphicPre(mid + "-4.png")} className="btn btn-secondary">Upcoming Tour</button>&nbsp;&nbsp;
               

                <button onClick={() => this.showCustom2Line("Next Stop: Czech Indoor Gala", "4 February - Ostrava (CZE)")} className="btn btn-secondary">Next Stop</button>&nbsp;&nbsp;

                <button onClick={() => this.showCustom2Line("© 2025 World Athletics", "All Rights Reserved")} className="btn btn-secondary">© 2025 World Athletics. All Rights Reserved</button>&nbsp;&nbsp;


                 <button onClick={() => this.showCustom2Line("New York, NY", "")} className="btn btn-secondary">New York, NY</button>&nbsp;&nbsp;

                <button onClick={() => this.showCustom2Line("Josh Kerr", "Men's NYRR Wanamaker Mile")} className="btn btn-secondary">Josh Kerr</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("Yared Nuguse", "Men's NYRR Wanamaker Mile")} className="btn btn-secondary">Yared Nuguse</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("Cole Hocker", "Men's 3000m")} className="btn btn-secondary">Cole Hocker</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("Georgia Bell", "Women's NYRR Wanamaker Mile")} className="btn btn-secondary">Georgia Bell</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("Jessica Hull", "Women's 3000m")} className="btn btn-secondary">Jessica Hull</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("Masai Russell", "Women's 60m Hurdles")} className="btn btn-secondary">Masai Russell</button>&nbsp;&nbsp;

                <button onClick={() => this.showCustom2Line("The Nike Track & Field Center at The Armory", "New York, NY")} className="btn btn-secondary">Nike T&F Center</button>&nbsp;&nbsp;

               

                <button onClick={() => this.showGraphicPre(mid + "-1.png")} className="btn btn-secondary">Timetable</button>&nbsp;&nbsp;
                <br />
                <br />
                <br />

                <button onClick={() => this.showGraphicPre(mid + "-2.png")} className="btn btn-secondary">Earlier</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-3.png")} className="btn btn-secondary">Yesterday</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-4.png")} className="btn btn-secondary">Boston 2/1 </button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-5.png")} className="btn btn-secondary">Still to Come (600m on)</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-7.png")} className="btn btn-secondary">Still to Come (3000, on)</button>&nbsp;&nbsp;

                <button onClick={() => this.showGraphicPre(mid + "-6.png")} className="btn btn-secondary">Upcoming Tour</button>&nbsp;&nbsp;
               

                <button onClick={() => this.showCustom2Line("Next Stop: Meeting Hauts-de-France Pas-de-Calais", "13 February - Liévin (FRA)")} className="btn btn-secondary">Next Stop</button>&nbsp;&nbsp;

                <button onClick={() => this.showCustom2Line("© 2025 World Athletics", "All Rights Reserved")} className="btn btn-secondary">© 2025 World Athletics. All Rights Reserved</button>&nbsp;&nbsp;

                  <br />
                <br />
                <button onClick={() => this.showGraphicPre(mid + "-2.png")} className="btn btn-secondary">Armory Mile ID</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-6.png")} className="btn btn-secondary">Armory Mile - Results Top Left</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-5.png")} className="btn btn-secondary">Armory Mile - Results Bottom Left</button>&nbsp;&nbsp;

                 <br />
                <br />
                <button onClick={() => this.showCustom2Line("Eric Holt", "Puma/Empire Elite TC")} className="btn btn-secondary">Eric Holt</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("Graham Blanks", "New Balance")} className="btn btn-secondary">Graham Blanks</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("Kenneth Ikeji", "Harvard")} className="btn btn-secondary">Kenneth Ikeji</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("Jon Molz", "Boston U. Coach and Meet Director")} className="btn btn-secondary"></button>&nbsp;&nbsp;

                <br />
                <br />
                <button onClick={() => this.showCustom2Line("The Nike Track & Field Center at The Armory", "New York, NY")} className="btn btn-secondary">Nike T&F Center</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("Elena Richards", "KPMG")} className="btn btn-secondary">Elena Richards</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("Arturis Spencer", "KPMG")} className="btn btn-secondary">Arturis Spencer</button>&nbsp;&nbsp;

                &nbsp;&nbsp;
                */}


                <button onClick={() => this.showGraphicPre(mid + "-1.png")} className="btn btn-secondary">Facility</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-2.png")} className="btn btn-secondary">Swim Commentators</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-3.png")} className="btn btn-secondary">Dive Commentators</button>&nbsp;&nbsp;
                <br />
                <br />

                <button onClick={() => this.showCustom2Line("Alachua County Sports & Events Center", "Gainesville , FL")} className="btn btn-secondary">Alachua County Sports & Events Center</button>&nbsp;&nbsp;

                <button onClick={() => this.showCustom2Line("© 2025 USATF","All Rights Reserved.")} className="btn btn-secondary">© Copyright USATF 2025</button>&nbsp;&nbsp;


                <br/>
                <br/>

                <button onClick={() => this.showCustom2Line("Virginia Beach Sports Center", "Virginia Beach, VA")} className="btn btn-secondary">Virginia Beach Sports Center</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("© 2025 FloSports, Inc.", "All Rights Reserved.")} className="btn btn-secondary">© 2025 FloSports, Inc. All Rights Reserved</button>&nbsp;&nbsp;

                <br />
                <br />
                <br />
                <button onClick={() => this.showCustom2Line("Albuquerque Convention Center", "Albuquerque, New Mexico")} className="btn btn-secondary">Albuquerque Convention Center</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("© 2025 FloSports, Inc.", "All Rights Reserved.")} className="btn btn-secondary">© 2025 FloSports, Inc. All Rights Reserved</button>&nbsp;&nbsp;

                <br />
                <br />
                <br />
                <button onClick={() => this.showCustom2Line("Boston University Track and Tennis Center", "Boston, MA")} className="btn btn-secondary">Boston University Track and Tennis Center</button>&nbsp;&nbsp;
                <br />
                <br />
                <br />


               
                
              
                


                

               

                <br />
                <br />

                <button onClick={() => this.showCustom2Line("© 2025 USATF","All Rights Reserved." )} className="btn btn-secondary">© Copyright USATF 2025</button>&nbsp;&nbsp;

                <button onClick={() => this.showCustom2Line("© 2025 FloSports, Inc.", "All Rights Reserved.")} className="btn btn-secondary">© 2025 FloSports, Inc. All Rights Reserved</button>&nbsp;&nbsp;

                <button onClick={() => this.showCustom2Line("© 2025 Armory Foundation", "All Rights Reserved.")} className="btn btn-secondary">© 2025 Armory Foundation All Rights Reserved</button>&nbsp;&nbsp;


                <button onClick={() => this.showCustom2Line("", "© 2025 ESPN, Inc. All Rights Reserved")} className="btn btn-secondary">© 2025 ESPN, Inc. All Rights Reserved</button>&nbsp;&nbsp;
              
                <br />
                <br />

                
                

                



                 
                <br /><br />

                
             {/*   


             <br /><br />

                             <button onClick={() => this.showCustom2Line("", "Produced by 45 Live & ABC7NY")} className="btn btn-secondary">Produced by 45 Live & ABC7NY</button>&nbsp;&nbsp;

                <button onClick={() => this.showGraphicPre(mid + "-3.png")} className="btn btn-secondary">Ryan Field</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-5.png")} className="btn btn-secondary">Sam Ryan</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-4.png")} className="btn btn-secondary">Sam+Carrie+Alysia</button>&nbsp;&nbsp;
             
                <button onClick={() => this.show2LineWithLogo("Rob Simmelkjar", "CEO of the New York Road Runners", "NYRR")} className="btn btn-secondary">Rob Simmelkjar</button>&nbsp;&nbsp;

                  <button onClick={() => this.showCustom2Line("", "© 2024 NYRR, Inc. All Rights Reserved")} className="btn btn-secondary">© 2024 NYRR. All Rights Reserved</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("", "© 2024 USATF")} className="btn btn-secondary">© Copyright USATF 2024</button>&nbsp;&nbsp;

             
             <br /><br />

             <button onClick={() => this.showGraphicPre(mid + "-2.png")} className="btn btn-secondary">Locator - Start Soon</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-1.png")} className="btn btn-secondary">Locator</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("", "New York, NY")} className="btn btn-secondary">New York, NY</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-3.png")} className="btn btn-secondary">Ryan Field</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-10.png")} className="btn btn-danger">5th Ave Mile</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-4.png")} className="btn btn-secondary">Sam+Carrie+Alysia</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-12.png")} className="btn btn-secondary">Kerr GFX</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-14.png")} className="btn btn-danger">Olympians Men</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-11.png")} className="btn btn-secondary">Coburn GFX</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-13.png")} className="btn btn-danger">Olympians Women</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-6.png")} className="btn btn-secondary">Ali Feller</button>&nbsp;&nbsp;
               
                <br />
                <br />
                <button onClick={() => this.show2LineWithLogo("TCS New York City Marathon", "Nov. 3rd 8am - ABC7NY and ESPN2", "TCSNYC")} className="btn btn-secondary">TCS New York City Marathon</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-5.png")} className="btn btn-secondary">Sam Ryan</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("NYPD vs FDNY", "NYPD leads FDNY 4-1")} className="btn btn-secondary">NYPD vs FDNY</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-15.png")} className="btn btn-danger">Women to Watch</button>&nbsp;&nbsp;
                <button onClick={() => this.show2LineWithLogo("Emma Coburn (USA)", "3-Time Olympian", "USA")} className="btn btn-secondary">Emma Coburn (USA) LT</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-16.png")} className="btn btn-danger">Men to Watch</button>&nbsp;&nbsp;<button onClick={() => this.show2LineWithLogo("Josh Kerr (GBR)", "2024 Olympic Silver Medalist", "GBR")} className="btn btn-secondary">Josh Kerr (GBR) LT</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-19.png")} className="btn btn-danger">Rebecca Social</button>&nbsp;&nbsp;
                <br />
                <br />
                

                <button onClick={() => this.show2LineWithLogo("Ted Metellus", "NYRR Sr. VP of Events / Race Director", "NYRR")} className="btn btn-secondary">Ted Metellus</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-4.png")} className="btn btn-secondary">Sam+Carrie+Alysia</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-17.png")} className="btn btn-danger">Top Stories - Women</button>&nbsp;&nbsp;
               


                <br />
                <br />
                <button onClick={() => this.showGraphicPre(mid + "-3.png")} className="btn btn-secondary">Ryan Field</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-18.png")} className="btn btn-danger">Top Stories - Men</button>&nbsp;&nbsp;

                <button onClick={() => this.showGraphicPre("blank.png")} className="btn btn-secondary">Blank</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-1.png")} className="btn btn-secondary">Locator - Start Soon</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-2.png")} className="btn btn-secondary">Locator - NYC</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-3.png")} className="btn btn-secondary">Sam Ryan</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-7.png")} className="btn btn-secondary">Mini 10K Pros FS</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-4.png")} className="btn btn-secondary">Sam, Carrie, Jacqui</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-8.png")} className="btn btn-secondary">Teferi FS</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-9.png")} className="btn btn-secondary">Ones to Watch FS</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-10.png")} className="btn btn-secondary">Americans in Paris FS</button>&nbsp;&nbsp;

                <button onClick={() => this.showGraphicPre(mid + "-5.png")} className="btn btn-secondary">Ali F.</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-6.png")} className="btn btn-secondary">Dani B.</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("Rob Simmelkjaer", "CEO NYRR")} className="btn btn-secondary">Rob S. - NYRR</button>&nbsp;&nbsp;


                <button onClick={() => this.showGraphicPre(mid + "-11.png")} className="btn btn-secondary">Top Stories - Carrie</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-12.png")} className="btn btn-secondary">Top Stories - Jaqui</button>&nbsp;&nbsp;

                <button onClick={() => this.showGraphicPre(mid + "-13.png")} className="btn btn-secondary">Chepkirui</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-14.png")} className="btn btn-secondary">Teferi</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-15.png")} className="btn btn-secondary">Lokedi</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-16.png")} className="btn btn-secondary">Kiplagat</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-17.png")} className="btn btn-secondary">Sisson</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-18.png")} className="btn btn-secondary">Huddle</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-19.png")} className="btn btn-secondary">Hall</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-20.png")} className="btn btn-secondary">Ichiyama</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-21.png")} className="btn btn-secondary">Lindwurm</button>&nbsp;&nbsp;


             <button onClick={() => this.showGraphicPre(mid + "-6.png")} className="btn btn-secondary">Start Times</button>&nbsp;&nbsp;<button onClick={() => this.showGraphicPre(mid + "-4.png")} className="btn btn-secondary">US Prize $</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-5.png")} className="btn btn-secondary">Intl Prize $</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-7.png")} className="btn btn-secondary">Men's Standings</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-8.png")} className="btn btn-secondary">Women's Standings</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-3.png")} className="btn btn-secondary">Points</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-10.png")} className="btn btn-secondary">Recent Winners</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-1.png")} className="btn btn-secondary">RC Schedule</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-2.png")} className="btn btn-secondary">OT Dates</button>&nbsp;&nbsp;

                <button onClick={() => this.showCustom2Line("SPIRE Institute", "")} className="btn btn-secondary">SPIRE Institute</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("Geneva, Ohio", "")} className="btn btn-secondary">Geneva, Ohio</button>&nbsp;&nbsp;
                <br /><br />
                <button onClick={() => this.showCustom2Line("Sports Performance Center", "Lubbock, Texas")} className="btn btn-secondary">Sports Performance Center</button>&nbsp;&nbsp;
                <br /><br />
                
                <button onClick={() => this.showGraphicPre(mid + "-5.png")} className="btn btn-secondary">Ivy - On the Call</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-6.png")} className="btn btn-secondary">Ivy - Sideline</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-3.png")} className="btn btn-secondary">Ivy Day 2 - Track</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-4.png")} className="btn btn-secondary">Ivy Day 2 - Field</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-7.png")} className="btn btn-secondary">Ivy - Day 1 Records Broken</button>&nbsp;&nbsp;

                <button onClick={() => this.showCustom2Line("Coverage Resumes at 11:58 AM ET", "Women's Triple Jump & Shot Put")} className="btn btn-secondary">Coverage Resumes</button>&nbsp;&nbsp; 

                <button onClick={() => this.showCustom3Line("Jason Saretsky", "	The William W. “Bill” McCurdy Director of T&F/XC","harvard")} className="btn btn-secondary">Jason Saretsky</button>&nbsp;&nbsp;  
                <button onClick={() => this.showCustom3Line("Fred Samara", "Retired in Spring After 46 Seasons","princeton")} className="btn btn-secondary">Fred Samara</button>&nbsp;&nbsp;  

                <button onClick={() => this.showCustom2Line("Hazel Clark", "Director of Global Sales & Business Development<br/>Bermuda Tourism Authority")} className="btn btn-secondary">Hazel Clark</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("Lewis Johnson", "")} className="btn btn-secondary">Lewis Johnson</button>&nbsp;&nbsp;

                <button onClick={() => this.showGraphicPre(mid + "-1.png")} className="btn btn-secondary">Upcoming Tour</button>&nbsp;&nbsp;

                <br />
                <br />
                <button onClick={() => this.showGraphicPre(mid + "-3.png")} className="btn btn-secondary">Yesterday</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-4.png")} className="btn btn-secondary">Earlier Today</button>&nbsp;&nbsp;
                
                <button onClick={() => this.showGraphicPre(mid + "-2.png")} className="btn btn-secondary">Women Standings</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-3.png")} className="btn btn-secondary">Points</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-6.png")} className="btn btn-secondary">Prize Money</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-7.png")} className="btn btn-secondary">Recent Winners</button>&nbsp;&nbsp;

                <button onClick={() => this.showGraphicPre(mid + "-11.png")} className="btn btn-secondary">OTQ</button>&nbsp;&nbsp;


                <button onClick={() => this.showGraphicPre(mid + "-8.png")} className="btn btn-secondary">Upcoming Events</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-9.png")} className="btn btn-secondary">Next on RC</button>&nbsp;&nbsp;

                <button onClick={() => this.showGraphicPre(mid + "-10.png")} className="btn btn-secondary">Tickets</button>&nbsp;&nbsp;


                <br /><br />

               
            
                <button onClick={() => this.showCustom2Line("Leonard Korir", "2022 USATF 25km Champion")} className="btn btn-secondary">Leonard Korir 2022</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("Keira D'Amato", "2022 USATF 25km Runner-up")} className="btn btn-secondary">Keira D'Amato 2022</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("Keira D'Amato", "")} className="btn btn-secondary">Keira D'Amato</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("Jacob Thomson", "")} className="btn btn-secondary">Jacob Thomson</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("Kevin Ullman", "")} className="btn btn-secondary">Kevin Ullman</button>&nbsp;&nbsp;



                
                <br /><br />

              
                <button onClick={() => this.show2LineWithLogo("Toyota USATF Outdoor Championships", "Buy your tickets today at usatf.org/tickets", "outdoors-23")} className="btn btn-secondary">USATF Outdoors Tickets</button>&nbsp;&nbsp;
                <button onClick={() => this.show2LineWithLogo("Follow USA Track & Field", "On Social Media @USATF", "usatf-wings")} className="btn btn-secondary">Follow USATF</button>&nbsp;&nbsp;
                <button onClick={() => this.show2LineWithLogo("Join or Renew Today", "usatf.org/membership", "usatf-wings")} className="btn btn-secondary">Join USATF</button>&nbsp;&nbsp;
                <button onClick={() => this.show2LineWithLogo("Support Team USATF", "Shop Today at usatf.org/store", "usatf-wings")} className="btn btn-secondary">Shop Today</button>&nbsp;&nbsp;
                <br /><br />
                <button onClick={() => this.show2LineWithLogo("USATF Women's 6km Championships", "July 15 in Canton, OH", "usatf-wings")} className="btn btn-secondary">Next Stop 6km</button>&nbsp;&nbsp;
                <button onClick={() => this.show2LineWithLogo("USATF Men's 8km Championships", "July 15 in Kingsport, TN", "usatf-wings")} className="btn btn-secondary">Next Stop 8km</button>&nbsp;&nbsp;

                <br /><br />
                <button onClick={() => this.show2LineWithLogo("1:03:00 Half Marathon", "Men's Olympic Team Trials - Marathon Standard", "usatf-wings")} className="btn btn-secondary">Men OTQ</button>&nbsp;&nbsp;
                <button onClick={() => this.show2LineWithLogo("1:12:00 Half Marathon ", "Women's Olympic Team Trials - Marathon Standard", "usatf-wings")} className="btn btn-secondary">Women OTQ</button>&nbsp;&nbsp;


                
                <button onClick={() => this.showCustom2Line("Devonshire, Bermuda", "")} className="btn btn-secondary">Devonshire, Bermuda</button>&nbsp;&nbsp;
                <button onClick={() => this.showCustom2Line("BDA National Sports Centre", "Devonshire, Bermuda")} className="btn btn-secondary">BDA National Sports Centre - Devonshire, Bermuda</button>&nbsp;&nbsp;
                 

                 
                <button onClick={() => this.showCustom2Line("", "© 2024 Big Ten Network. All Rights Reserved.")} className="btn btn-secondary">© 2024 Big Ten Network. All Rights Reserved.</button>&nbsp;&nbsp;

                 */}

            </div>
            <br />
            <div id="customGraphic">
                <button onClick={() => this.showGraphic()} className="btn btn-secondary">Show Custom Graphic</button>
                <input type="text" ref={input => this.graphicSRC = input} placeholder="filename" />
            </div>

            <br/><br/>
            <div>
                
               
                {/* 
                                */}
                <br />
            </div>     

            <br /><br />
            
            {/* 
            
            <div>
                <button onClick={() => this.showGraphicPre(mid + "-3.png")} className="btn btn-secondary">5175-3 Schedule</button>&nbsp;&nbsp;
                <button onClick={() => this.showGraphicPre(mid + "-4.png")} className="btn btn-secondary">5175-4 Points</button>&nbsp;&nbsp;

                <button onClick={() => this.showGraphicPre(mid + "-5.png")} className="btn btn-secondary">5175-5 W Standings</button>&nbsp;&nbsp;

                <button onClick={() => this.showGraphicPre(mid + "-6.png")} className="btn btn-secondary">5175-6 M Standings</button>&nbsp;&nbsp;

                <button onClick={() => this.showGraphicPre(mid + "-7.png")} className="btn btn-secondary">5175-7 Prize Race</button>&nbsp;&nbsp;

                <button onClick={() => this.showGraphicPre(mid + "-7b.png")} className="btn btn-secondary">5175-7b Prize RC</button>&nbsp;&nbsp;

                <button onClick={() => this.showGraphicPre(mid + "-11.png")} className="btn btn-secondary">5175-11 Men's CR</button>&nbsp;&nbsp;

                <button onClick={() => this.showGraphicPre(mid + "-11b.png")} className="btn btn-secondary">5175-11b Women's CR</button>&nbsp;&nbsp;

                <button onClick={() => this.showGraphicPre(mid + "-16.png")} className="btn btn-secondary">5175-16 Schedule</button>&nbsp;&nbsp;
            </div>
            
            */}
            <br /><hr /><br />
            <div>
                <div>
                    Field Bar 1: <input id="fb1" placeholder="1-1" />
                    <button onClick={() => this.setFieldBarEvent(1)} className="btn btn-secondary">Set Field Sidebar 1</button>
                    <button onClick={() => this.setFieldBarShow(1, true)} className="btn btn-secondary">Show Bar</button>
                    <button onClick={() => this.setFieldBarShow(1, false)} className="btn btn-secondary">Hide Bar</button>
                    <button onClick={() => this.setFieldBarCC(1, true)} className="btn btn-secondary">CC On</button>
                    <button onClick={() => this.setFieldBarCC(1, false)} className="btn btn-secondary">CC Off</button>
                    <button onClick={() => this.setFieldBarResults(1, true)} className="btn btn-secondary">Results On</button>
                    <button onClick={() => this.setFieldBarResults(1, false)} className="btn btn-secondary">Results Off</button>
                    <button onClick={() => this.setFieldBarEnglish(1, true)} className="btn btn-secondary">English On</button>
                    <button onClick={() => this.setFieldBarEnglish(1, false)} className="btn btn-secondary">English Off</button>
                    <button onClick={() => this.setFieldBarBoth(1, true)} className="btn btn-secondary">Show Both</button>
                    <button onClick={() => this.setFieldBarBoth(1, false)} className="btn btn-secondary">Hide Both</button>

                </div>

                <div>
                    Field Bar 2: <input id="fb2" placeholder="2-1" />
                    <button onClick={() => this.setFieldBarEvent(2)} className="btn btn-secondary">Set Field Sidebar 2</button>
                    <button onClick={() => this.setFieldBarShow(2, true)} className="btn btn-secondary">Show Bar</button>
                    <button onClick={() => this.setFieldBarShow(2, false)} className="btn btn-secondary">Hide Bar</button>
                    <button onClick={() => this.setFieldBarCC(2, true)} className="btn btn-secondary">CC On</button>
                    <button onClick={() => this.setFieldBarCC(2, false)} className="btn btn-secondary">CC Off</button>
                    <button onClick={() => this.setFieldBarResults(2, true)} className="btn btn-secondary">Results On</button>
                    <button onClick={() => this.setFieldBarResults(2, false)} className="btn btn-secondary">Results Off</button>
                    <button onClick={() => this.setFieldBarEnglish(2, true)} className="btn btn-secondary">English On</button>
                    <button onClick={() => this.setFieldBarEnglish(2, false)} className="btn btn-secondary">English Off</button>
                    <button onClick={() => this.setFieldBarBoth(2, true)} className="btn btn-secondary">Show Both</button>
                    <button onClick={() => this.setFieldBarBoth(2, false)} className="btn btn-secondary">Hide Both</button>
                </div>

                <div>
                    Field Bar 3: <input id="fb3" placeholder="3-1" />
                    <button onClick={() => this.setFieldBarEvent(3)} className="btn btn-secondary">Set Field Sidebar 3</button>
                    <button onClick={() => this.setFieldBarShow(3, true)} className="btn btn-secondary">Show Bar</button>
                    <button onClick={() => this.setFieldBarShow(3, false)} className="btn btn-secondary">Hide Bar</button>
                    <button onClick={() => this.setFieldBarCC(3, true)} className="btn btn-secondary">CC On</button>
                    <button onClick={() => this.setFieldBarCC(3, false)} className="btn btn-secondary">CC Off</button>
                    <button onClick={() => this.setFieldBarResults(3, true)} className="btn btn-secondary">Results On</button>
                    <button onClick={() => this.setFieldBarResults(3, false)} className="btn btn-secondary">Results Off</button>
                    <button onClick={() => this.setFieldBarEnglish(3, true)} className="btn btn-secondary">English On</button>
                    <button onClick={() => this.setFieldBarEnglish(3, false)} className="btn btn-secondary">English Off</button>
                    <button onClick={() => this.setFieldBarBoth(3, true)} className="btn btn-secondary">Show Both</button>
                    <button onClick={() => this.setFieldBarBoth(3, false)} className="btn btn-secondary">Hide Both</button>
                </div>

               
                <div>
                    Field Bar 4 Event: <input id="fb4" placeholder="4-1" />
                    <button onClick={() => this.setFieldBarEvent(4)} className="btn btn-secondary">Set Field Sidebar 4</button>
                    <button onClick={() => this.setFieldBarShow(4, true)} className="btn btn-secondary">Show Bar</button>
                    <button onClick={() => this.setFieldBarShow(4, false)} className="btn btn-secondary">Hide Bar</button>
                    <button onClick={() => this.setFieldBarCC(4, true)} className="btn btn-secondary">CC On</button>
                    <button onClick={() => this.setFieldBarCC(4, false)} className="btn btn-secondary">CC Off</button>
                    <button onClick={() => this.setFieldBarResults(4, true)} className="btn btn-secondary">Results On</button>
                    <button onClick={() => this.setFieldBarResults(4, false)} className="btn btn-secondary">Results Off</button>
                    <button onClick={() => this.setFieldBarEnglish(4, true)} className="btn btn-secondary">English On</button>
                    <button onClick={() => this.setFieldBarEnglish(4, false)} className="btn btn-secondary">English Off</button>
                    <button onClick={() => this.setFieldBarBoth(4, true)} className="btn btn-secondary">Show Both</button>
                    <button onClick={() => this.setFieldBarBoth(4, false)} className="btn btn-secondary">Hide Both</button>
                </div>
                

                <div>
                    Field Bar 5 Event: <input id="fb5" placeholder="5-1" />
                    <button onClick={() => this.setFieldBarEvent(5)} className="btn btn-secondary">Set Field Sidebar 5</button>
                    <button onClick={() => this.setFieldBarShow(5, true)} className="btn btn-secondary">Show Bar</button>
                    <button onClick={() => this.setFieldBarShow(5, false)} className="btn btn-secondary">Hide Bar</button>
                    <button onClick={() => this.setFieldBarCC(5, true)} className="btn btn-secondary">CC On</button>
                    <button onClick={() => this.setFieldBarCC(5, false)} className="btn btn-secondary">CC Off</button>
                    <button onClick={() => this.setFieldBarResults(5, true)} className="btn btn-secondary">Results On</button>
                    <button onClick={() => this.setFieldBarResults(5, false)} className="btn btn-secondary">Results Off</button>
                    <button onClick={() => this.setFieldBarEnglish(5, true)} className="btn btn-secondary">English On</button>
                    <button onClick={() => this.setFieldBarEnglish(5, false)} className="btn btn-secondary">English Off</button>
                    <button onClick={() => this.setFieldBarBoth(5, true)} className="btn btn-secondary">Show Both</button>
                    <button onClick={() => this.setFieldBarBoth(5, false)} className="btn btn-secondary">Hide Both</button>
                </div>

                <div>
                    Field Bar 6 Event: <input id="fb6" placeholder="6-1" />
                    <button onClick={() => this.setFieldBarEvent(6)} className="btn btn-secondary">Set Field Sidebar 6</button>
                    <button onClick={() => this.setFieldBarShow(6, true)} className="btn btn-secondary">Show Bar</button>
                    <button onClick={() => this.setFieldBarShow(6, false)} className="btn btn-secondary">Hide Bar</button>
                    <button onClick={() => this.setFieldBarCC(6, true)} className="btn btn-secondary">CC On</button>
                    <button onClick={() => this.setFieldBarCC(6, false)} className="btn btn-secondary">CC Off</button>
                    <button onClick={() => this.setFieldBarResults(6, true)} className="btn btn-secondary">Results On</button>
                    <button onClick={() => this.setFieldBarResults(6, false)} className="btn btn-secondary">Results Off</button>
                    <button onClick={() => this.setFieldBarEnglish(6, true)} className="btn btn-secondary">English On</button>
                    <button onClick={() => this.setFieldBarEnglish(6, false)} className="btn btn-secondary">English Off</button>
                    <button onClick={() => this.setFieldBarBoth(6, true)} className="btn btn-secondary">Show Both</button>
                    <button onClick={() => this.setFieldBarBoth(6, false)} className="btn btn-secondary">Hide Both</button>

                </div>

                 <div>
                    Field Bar 7 Event: <input id="fb7" placeholder="7-1" />
                    <button onClick={() => this.setFieldBarEvent(7)} className="btn btn-secondary">Set Field Sidebar 7</button>
                    <button onClick={() => this.setFieldBarShow(7, true)} className="btn btn-secondary">Show Bar</button>
                    <button onClick={() => this.setFieldBarShow(7, false)} className="btn btn-secondary">Hide Bar</button>
                    <button onClick={() => this.setFieldBarCC(7, true)} className="btn btn-secondary">CC On</button>
                    <button onClick={() => this.setFieldBarCC(7, false)} className="btn btn-secondary">CC Off</button>
                    <button onClick={() => this.setFieldBarResults(7, true)} className="btn btn-secondary">Results On</button>
                    <button onClick={() => this.setFieldBarResults(7, false)} className="btn btn-secondary">Results Off</button>
                    <button onClick={() => this.setFieldBarEnglish(7, true)} className="btn btn-secondary">English On</button>
                    <button onClick={() => this.setFieldBarEnglish(7, false)} className="btn btn-secondary">English Off</button>
                    <button onClick={() => this.setFieldBarBoth(7, true)} className="btn btn-secondary">Show Both</button>
                    <button onClick={() => this.setFieldBarBoth(7, false)} className="btn btn-secondary">Hide Both</button>

                </div>
                <div>
                    Field Bar 8 Event: <input id="fb8" placeholder="8-1" />
                    <button onClick={() => this.setFieldBarEvent(8)} className="btn btn-secondary">Set Field Sidebar 8</button>
                    <button onClick={() => this.setFieldBarShow(8, true)} className="btn btn-secondary">Show Bar</button>
                    <button onClick={() => this.setFieldBarShow(8, false)} className="btn btn-secondary">Hide Bar</button>
                    <button onClick={() => this.setFieldBarCC(8, true)} className="btn btn-secondary">CC On</button>
                    <button onClick={() => this.setFieldBarCC(8, false)} className="btn btn-secondary">CC Off</button>
                    <button onClick={() => this.setFieldBarResults(8, true)} className="btn btn-secondary">Results On</button>
                    <button onClick={() => this.setFieldBarResults(8, false)} className="btn btn-secondary">Results Off</button>
                    <button onClick={() => this.setFieldBarEnglish(8, true)} className="btn btn-secondary">English On</button>
                    <button onClick={() => this.setFieldBarEnglish(8, false)} className="btn btn-secondary">English Off</button>
                    <button onClick={() => this.setFieldBarBoth(8, true)} className="btn btn-secondary">Show Both</button>
                    <button onClick={() => this.setFieldBarBoth(8, false)} className="btn btn-secondary">Hide Both</button>

                </div>

                <div>
                    Field Bar 9 (NBC) Event: <input id="fb9" placeholder="9-1" />
                    <button onClick={() => this.setFieldBarEvent(9)} className="btn btn-secondary">Set Field Sidebar 9</button>
                    <button onClick={() => this.setFieldBarShow(9, true)} className="btn btn-secondary">Show Bar</button>
                    <button onClick={() => this.setFieldBarShow(9, false)} className="btn btn-secondary">Hide Bar</button>
                    <button onClick={() => this.setFieldBarCC(9, true)} className="btn btn-secondary">CC On</button>
                    <button onClick={() => this.setFieldBarCC(9, false)} className="btn btn-secondary">CC Off</button>
                    <button onClick={() => this.setFieldBarResults(9, true)} className="btn btn-secondary">Results On</button>
                    <button onClick={() => this.setFieldBarResults(9, false)} className="btn btn-secondary">Results Off</button>
                    <button onClick={() => this.setFieldBarEnglish(9, true)} className="btn btn-secondary">English On</button>
                    <button onClick={() => this.setFieldBarEnglish(9, false)} className="btn btn-secondary">English Off</button>
                    <button onClick={() => this.setFieldBarBoth(9, true)} className="btn btn-secondary">Show Both</button>
                    <button onClick={() => this.setFieldBarBoth(9, false)} className="btn btn-secondary">Hide Both</button>

                </div>

            </div>

            <br /><hr /><br />
            <div>
                <select id="multibox" onChange={this.setBoxCount}>
                    <option value="zero">0 - Hide All</option>
                    <option value="one">1</option>
                    <option value="two">2</option>
                    <option value="three">3</option>
                    <option value="four">4</option>
                </select>
                <div>
                    Box 1 Event: <input id="box1" placeholder="1-1" />
                    <button onClick={() => this.setBoxEvent(1)} className="btn btn-secondary">Set Box 1</button>
                    <button onClick={() => this.setBoxCCShow(1, true)} className="btn btn-secondary">Show Bar</button>
                    <button onClick={() => this.setBoxCCShow(1, false)} className="btn btn-secondary">Hide Bar</button>
                    <button onClick={() => this.setBoxCC(1, true)} className="btn btn-secondary">CC On</button>
                    <button onClick={() => this.setBoxCC(1, false)} className="btn btn-secondary">CC Off</button>
                    <button onClick={() => this.setBoxCC2(1, true)} className="btn btn-secondary">CC2 On</button>
                    <button onClick={() => this.setBoxCC2(1, false)} className="btn btn-secondary">CC2 Off</button>
                    {/* 
                    <button onClick={() => this.setBoxResults(1, true)} className="btn btn-secondary">Results On</button>
                    <button onClick={() => this.setBoxResults(1, false)} className="btn btn-secondary">Results Off</button>
                    */}

                </div>
                <div>
                    Box 2 Event: <input id="box2" placeholder="2-1" />
                    <button onClick={() => this.setBoxEvent(2)} className="btn btn-secondary">Set Box 2</button>
                    <button onClick={() => this.setBoxCCShow(2, true)} className="btn btn-secondary">Show Bar</button>
                    <button onClick={() => this.setBoxCCShow(2, false)} className="btn btn-secondary">Hide Bar</button>
                    <button onClick={() => this.setBoxCC(2, true)} className="btn btn-secondary">CC On</button>
                    <button onClick={() => this.setBoxCC(2, false)} className="btn btn-secondary">CC Off</button>
                    <button onClick={() => this.setBoxCC2(2, true)} className="btn btn-secondary">CC2 On</button>
                    <button onClick={() => this.setBoxCC2(2, false)} className="btn btn-secondary">CC2 Off</button>
                    {/* 
                    <button onClick={() => this.setBoxResults(2, true)} className="btn btn-secondary">Results On</button>
                    <button onClick={() => this.setBoxResults(2, false)} className="btn btn-secondary">Results Off</button>
                     */}
                </div>
                <div>
                    Box 3 Event: <input id="box3" placeholder="3-1" />
                    <button onClick={() => this.setBoxEvent(3)} className="btn btn-secondary">Set Box 3</button>
                    <button onClick={() => this.setBoxCCShow(3, true)} className="btn btn-secondary">Show Bar</button>
                    <button onClick={() => this.setBoxCCShow(3, false)} className="btn btn-secondary">Hide Bar</button>
                    <button onClick={() => this.setBoxCC(3, true)} className="btn btn-secondary">CC On</button>
                    <button onClick={() => this.setBoxCC(3, false)} className="btn btn-secondary">CC Off</button>
                    <button onClick={() => this.setBoxCC2(3, true)} className="btn btn-secondary">CC2 On</button>
                    <button onClick={() => this.setBoxCC2(3, false)} className="btn btn-secondary">CC2 Off</button>
                    {/* 
                    <button onClick={() => this.setBoxResults(3, true)} className="btn btn-secondary">Results On</button>
                    <button onClick={() => this.setBoxResults(3, false)} className="btn btn-secondary">Results Off</button>
                     */}
                </div>
                <div>
                    Box 4 Event: <input id="box4" placeholder="4-1" />
                    <button onClick={() => this.setBoxEvent(4)} className="btn btn-secondary">Set Box 4</button>
                    <button onClick={() => this.setBoxCCShow(4, true)} className="btn btn-secondary">Show Bar</button>
                    <button onClick={() => this.setBoxCCShow(4, false)} className="btn btn-secondary">Hide Bar</button>
                    <button onClick={() => this.setBoxCC(4, true)} className="btn btn-secondary">CC On</button>
                    <button onClick={() => this.setBoxCC(4, false)} className="btn btn-secondary">CC Off</button>
                    <button onClick={() => this.setBoxCC2(4, true)} className="btn btn-secondary">CC2 On</button>
                    <button onClick={() => this.setBoxCC2(4, false)} className="btn btn-secondary">CC2 Off</button>
                    {/* 
                    <button onClick={() => this.setBoxResults(4, true)} className="btn btn-secondary">Results On</button>
                    <button onClick={() => this.setBoxResults(4, false)} className="btn btn-secondary">Results Off</button>
                     */}
                </div>


            </div>



        </div>

    }
}

RightBar.propTypes = {
    athleteInfo: PropTypes.object
};

ScheduleDay.propTypes = {
    eventClick: PropTypes.func
};

ScheduleEvent.propTypes = {
    eventClick: PropTypes.func
};

SelectedEvent.propTypes = {
    currentEvent: PropTypes.object,
    athleteClick: PropTypes.func
};

StartList.propTypes = {
    entries: PropTypes.object,
    athleteClick: PropTypes.func
};

TrackResults.propTypes = {
    entries: PropTypes.object,
    athleteClick: PropTypes.func
};

HFieldResults.propTypes = {
    entries: PropTypes.object,
    athleteClick: PropTypes.func
};

VFieldResults.propTypes = {
    entries: PropTypes.object,
    athleteClick: PropTypes.func
};

EventGraphics.propTypes = {
    entries: PropTypes.object,
    athleteClick: PropTypes.func
};

function sortPlaces(a, b) {
    var aPlace, bPlace;

    if (a.P) {
        aPlace = a.P;
    } else if (a.DNS) {
        aPlace = 999999999;
    } else if (a.DQ) {
        aPlace = 999999995;
    } else if (a.DNF) {
        aPlace = 999999990;
    } else if (a.SPD) {
        if (Array.isArray(a.SPD)) {
            var sl = a.SPD.length - 1;
            aPlace = 100000000 - (a.SPD[sl].L * 100000) + a.SPD[sl].P;
        } else {
            for (var sp in a.SPD) {
                aPlace = 100000000 - (a.SPD[sp].L * 100000) + a.SPD[sp].P;
            }
        }
        //aPlace = a.SPD[cl] ? a.SPD[cl].P : undefined;
    } else {
        if (a.HSF && a.LP)
            aPlace = a.HSF * 100000000 + parseInt(a.LP, 10);
        else
            aPlace = 999999999;
    }

    if (b.P) {
        bPlace = b.P;
    } else if (b.DNS) {
        bPlace = 999999999;
    } else if (b.DQ) {
        bPlace = 999999995;
    } else if (b.DNF) {
        bPlace = 999999990;
    } else if (b.SPD) {
        if (Array.isArray(b.SPD)) {
            var sl = b.SPD.length - 1;
            bPlace = 100000000 - (b.SPD[sl].L * 100000) + b.SPD[sl].P;
        }
        else {
            for (var sp in b.SPD) {
                bPlace = 100000000 - (b.SPD[sp].L * 100000) + b.SPD[sp].P;
            }
        }
        //aPlace = a.SPD[cl] ? a.SPD[cl].P : undefined;
    } else {
        if (b.HSF && b.LP)
            bPlace = b.HSF * 100000000 + parseInt(b.LP, 10);
        else
            bPlace = 999999999;
    }
    if (!aPlace)
        return 1;
    if (!bPlace)
        return -1;
    if (aPlace < bPlace) {
        a.sortPlace = aPlace;
        b.sortPlace = bPlace;
        return -1;
    }
    if (aPlace > bPlace) {
        a.sortPlace = aPlace;
        b.sortPlace = bPlace;
        return 1;
    }
    a.sortPlace = aPlace;
    b.sortPlace = bPlace;
    return 0;
}

function sortPos(a, b) {
    var aPlace, bPlace;

    if (a.PF) {
        aPlace = a.PF;
    } else if (a.DNS) {
        aPlace = 999999;
    } else if (a.DQ) {
        aPlace = 999995;
    } else if (a.DNF) {
        aPlace = 999990;
    } else {
        if (a.HSF && a.LP)
            aPlace = a.HSF * 1000 + parseInt(a.LP, 10);
        else
            aPlace = 999999;
    }

    if (b.PF) {
        bPlace = b.PF;
    } else if (b.DNS) {
        bPlace = 999999;
    } else if (b.DQ) {
        bPlace = 999995;
    } else if (b.DNF) {
        bPlace = 999990;
    } else {
        if (b.HSF && b.LP)
            bPlace = b.HSF * 1000 + parseInt(b.LP, 10);
        else
            bPlace = 999999;
    }


    if (!aPlace)
        return 1;
    if (!bPlace)
        return -1;
    if (aPlace < bPlace) {
        a.sortPlace = aPlace;
        b.sortPlace = bPlace;
        return -1;
    }
    if (aPlace > bPlace) {
        a.sortPlace = aPlace;
        b.sortPlace = bPlace;
        return 1;
    }
    a.sortPlace = aPlace;
    b.sortPlace = bPlace;
    return 0;
}


ReactDOM.render(<FranklinApp en={undefined} meetID={mid || undefined} />, document.getElementById('franklinApp'));